/**
 * 🤝 딜등록 요청 — 벤더 딜등록 목록, 인포트렌드부터 (v2.140.0 · 2026-09-08 / 정보 요청 메일 v2.141.0)
 *
 * 무엇인가
 *   제안사(Tier 2)가 잡은 프로젝트를 우리가 벤더(인포트렌드 대만 본사)에 딜등록해 둔 목록이다.
 *   지금까지 엑셀 한 파일(연도별 시트)로 관리하던 것을 옮겼다(2025·2026 자료). 접수번호·Project ID·만료·연장 마감을 여기서 본다.
 *   사용자 계획: 인포트렌드 한 가지로 시작하고 나중에 시게이트·기타 벤더를 탭으로 늘린다(벤더 칸이 이미 있다).
 *
 * 흐름 (v2.141.0 부터 앞 단계까지)
 *   ① [✉ 정보 요청] — 제안사 담당자에게 「딜등록정보요청」 양식(엑셀)을 채워 메일로 보낸다 → [✉ 정보 요청 N] 탭에 기록
 *   ② 회신이 오면 그 기록의 [딜등록으로 만들기] — 새 딜등록 창이 제안사·엔드유저·프로젝트로 채워져 뜬다 → 넣으면 요청과 연결
 *   ③ 인포트렌드 본사에 등록해 접수번호·Project ID 를 받으면 [수정] 으로 적는다
 *
 * 포털에서 시작하는 흐름 (v2.189.0 · 2026-09-17 · 사용자 지시)
 *   ① 영업담당자가 [＋ 새 딜등록] 으로 적으면 상태는 **승인대기(Pending)** — 저장하는 순간
 *      **딜등록 요청 메시지방**(만료 알림과 같은 방)에 봇이 내용을 요약해 올린다(빈 칸은 빼고).
 *   ② 영업지원이 그 글을 복사해 인포트렌드 담당자에게 넘긴다.
 *   ③ 거절되면 상태를 **Rejected(거절)** 로 바꾼다 — 종료로 친다.
 *   ④ 승인되면 **접수번호**를 적는다 → 상태가 저절로 **진행(On-going)** 이 되고 신청일(그날)·
 *      만료일(+6개월)이 채워지며, 방에 「번호 부여」 안내가 올라간다. 판정은 rules.ts 한 곳.
 *   ⑤ 며칠 뒤 **Project ID** 를 받아 적으면 딜등록 안내 메일을 보낼 수 있다(2단계).
 *   ⚠승인대기 건은 **만료 임박 알림·대시보드에 들어가지 않는다** — 아직 만료일이 없다.
 *   ④ 만료가 다가오면 줄의 ✉ 로 만료 안내 메일 (v2.140.0)
 *
 * 화면
 *   위   벤더 탭(지금은 인포트렌드 하나) · [진행 중 N] [종료 N] [✉ 정보 요청 N] · 종료는 연도 칩 · [⏰ 만료 임박] · 검색 · 상태·담당자 필터 ·
 *        [필터·정렬 초기화 ▼] · [📐 내 표 설정 | ↺ 초기화] · [📥 엑셀] · [✏ 만료 안내 문구] · [✉ 정보 요청] · [＋ 새 딜등록]
 *        (v2.147.0: 담당자 고르기 칸은 없앴다 — 표 머리글 「담당자」 옆 🔍 로 고른다)
 *   표   기본 칸 = 번호(접수번호/Project ID) · 상태 · 신청/만료 · 연장 마감(D-day) · 제안사 · 엔드유저 · 프로젝트 · **금액(USD)** ·
 *        담당자 · ✉ (v2.144.0 부터 공용 DataTable · 금액은 v2.145.0)
 *        · **머리글 클릭 = 정렬**(오름→내림→해제 · 다른 머리글을 누르면 다단계) · 머리글 옆 🔍 = 값 골라 보기(엑셀식 연쇄 필터)
 *        · **📐 내 표 설정** — 켜면 ⚙ 표시 컬럼(낱개 접수번호·Project ID·신청일·만료일·D-day·제안사 담당자·P/N·애플리케이션·영업진행·
 *          최근 갱신·종료일·정보 요청·비고·Remark 를 켜고 끔) · 머리글 끌어 순서 · 우측 끝 끌어 너비 — 사용자 환경설정(dealTab*)에 저장
 *        ⭐칸을 늘리지 않으려고 **한 칸에 두 줄**로 접었다(번호·기간). 긴 글 칸은 `max-w-0` + truncate 로 표가 화면 폭을 넘지 않게.
 *        줄을 누르면 상세 창, 거기서 [수정] · [삭제] · [✉ 만료 안내 메일] · [✉ 딜등록 안내].
 *        (⛔상세의 [✉ 정보 요청] 은 v2.193.2 에서 뺐다 — 정보 요청은 **딜을 만들기 전** 절차다.)
 *        표 아래 줄 수 옆에 **지금 보이는 줄의 금액 합계** (v2.145.0 — 탭·검색·필터를 바꾸면 같이 바뀐다).
 *   ⭐금액(USD)은 v2.145.0 에서 「비고」 칸에 숫자로 묻혀 있던 딜 금액을 뺀 것이다(엑셀 셀 서식 $#,##0 으로 확정).
 *     비고에는 진짜 메모만 남는다 — 같은 값이 두 칸에 적히는 자리를 안 만든다.
 *   제안사 담당자 명단은 v2.143.0 부터 **거래처 담당자 주소록**(거래처 관리 › 👤 거래처 담당자)이다 — 딜의 [수정] 에서 고르거나
 *   [＋ 새 담당자] 로 넣는다. 딜은 제안사 업체(거래처) · 담당자(주소록) · 영업진행 건에 연결된다(v2.143.0).
 *
 * v2.215.0 (2026-09-29 · 사용자 지시) — 월간 만료 안내 · 상태 드롭다운 · 종료 탭 넘기기
 *   · 목록의 **상태 칸을 누르면 드롭다운**으로 바로 바꾼다(DealStatusSelect · 서버 PATCH /:id/status).
 *   · ⭐종료 상태로 바꿔도 **진행 중 탭에 남는다** — 탭은 사람이 넘긴 기록(archived)으로 가른다.
 *     [📦 종료 탭으로 넘기기 N] 으로 골라 넘긴다(DealArchiveModal). 종료 탭 딜을 진행으로 되돌리면 진행 중 탭으로 돌아온다.
 *   · [⏰ 만료 임박] = **24일 검토 표 · 25일 엑셀에 나갈 딜 그대로**(isMonthlyReviewRow — 넘기기 전 실주·무효 포함).
 *   · 옛 [🔔 알림 시험발송] 단추 → [🔔 월간 안내 ▼] 메뉴(미리보기 누구나 · 시험발송 관리자 · DealMonthlyNoticeMenu).
 *   · v2.219.0 [📥 만료예정 상태표] — 25일 엑셀을 누른 순간의 자료로(DealStatusXlsxButton · 서버가 같은 조립 함수로 만든다).
 *
 * 판정은 서버가 한다 — 진행 중/종료(isClosed)·마감까지 남은 날(dday)·종료 연도(closedYear)를 서버 값 그대로 쓴다.
 *   만료일·마감일 기본값(+6개월·+3일)만 **입력 편의로** 화면에서도 채운다(숫자는 서버 meta.rule 에서 받는다).
 *
 * ⚠viewer(조회 전용)는 메뉴에도 없고 서버도 403 — 제안사 담당자 연락처·프로젝트 진행 내용이 그대로 있어서.
 * ⚠입력 창은 배경을 눌러도 닫히지 않는다(닫기는 [취소]·× 로만 — `check:modal` 규칙).
 */

import { useEffect, useMemo, useRef, useState } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { Link, useSearchParams } from 'react-router-dom';
import {
  listDeals, getDeal, getDealMeta, createDeal, updateDeal, deleteDeal, getExpiryMailDraft, markExpiryMailSent,
  listRequests, deleteRequest, getNoticeMailDraft, setDealStatus, listArchiveCandidates, type NoticeTarget,
  findKnownEnglish, type KnownField,
  addDealUpdate, editDealUpdate, removeDealUpdate, getDealAudit,
  type DealRow, type DealLastChange, type DealInput, type DealItem, type DealStatus, type DealScope,
  type DealRequestRow, type DealRequestInput,
} from '../lib/deal-registration-api';
// 제안사 담당자 = 거래처 담당자 주소록 (v2.143.0) — 거래처 관리 › 👤 거래처 담당자 와 같은 표
import {
  listContacts, listContactCompanies, createContact, emptyContactInput,
  type PartnerContactInput,
} from '../lib/partner-contact-api';
// 제안 품목을 인포트렌드 가격표에서 찾아 넣기 (v2.151.0)
import { searchInfortrendParts, listPartGroups, hasMainPart, type InfortrendSearchRow, type PartGroup } from '../lib/infortrend-api';
import {
  STATUS_BADGE, EXPIRING_DAYS, tier2Short, dealEndUser, dealTopic, specLine, ddayText, isExpiring, isMonthlyReviewRow, mmdd, dealCompanyLabel,
} from '../lib/deal-display';
import { DealStatusSelect, statusShort } from '../components/DealStatusSelect';
import { DealArchiveModal } from '../components/DealArchiveModal';
import { DealMonthlyNoticeMenu } from '../components/DealMonthlyNoticeMenu';
import { DealStatusXlsxButton } from '../components/DealStatusXlsxButton';
import { DateInput } from '../components/DateInput';
import { ComboboxInput } from '../components/ComboboxInput';
import { SalesPickerModal } from '../components/SalesPickerModal';
import { DealRequestDialog } from '../components/DealRequestDialog';
import { ExpiryMailTemplateModal } from '../components/ExpiryMailTemplateModal';
import { DealUpdatePhrasePicker } from '../components/DealUpdatePhrasePicker';
import { exportRowsToExcel, dateStamp } from '../lib/excelExport';
// 📐 내 표 설정 · 정렬 · 필터 — 영업진행·매입관리와 같은 공용 부품 (v2.144.0)
import { useColState, applyColState, ColumnHeader, type Column } from '../components/DataTable';
import { ExcelModeGroup } from '../components/ExcelModeButton';
import { ResetMenu } from '../components/ResetButton';
import * as prefsApi from '../lib/preferences-api';
import { resolveActiveColumns, resolveColumnOrder } from '../lib/columnPrefs';
import type { UserPreferences } from '../lib/types';
import { useAuth } from '../lib/auth-context';
import { mailSubject } from '../lib/mail-subject';
import { openMailCompose } from '../lib/mail-compose';
import { PageTabs } from '../components/ui/PageTabs';
import { SegmentedControl } from '../components/ui/SegmentedControl';
import { LoadingLines } from '../components/ui/Skeleton';

/* 표시용 다듬기(tier2Short · endUserShort · projectTitle · ddayText …)는 lib/deal-display.ts — 대시보드와 같이 쓴다 (v2.142.0) */

/* ── 날짜 기본값 (입력 편의) — 규칙 숫자는 서버 meta.rule, 계산은 backend rules.ts 와 같은 방식 ── */

function daysInMonth(y: number, m0: number): number {
  return new Date(Date.UTC(y, m0 + 1, 0)).getUTCDate();
}
/** 엑셀 EDATE 처럼 말일을 넘기지 않는다(8/31 + 6개월 = 2/28) */
function addMonths(ymd: string, months: number): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(ymd);
  if (!m) return ymd;
  const total = Number(m[1]) * 12 + (Number(m[2]) - 1) + months;
  const y = Math.floor(total / 12);
  const mo = total - y * 12;
  const d = Math.min(Number(m[3]), daysInMonth(y, mo));
  return `${y}-${String(mo + 1).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
}
function addDays(ymd: string, days: number): string {
  const t = Date.parse(`${ymd}T00:00:00Z`);
  if (Number.isNaN(t)) return ymd;
  return new Date(t + days * 86400000).toISOString().slice(0, 10);
}
/* ── 폼 ─────────────────────────────────────────── */

/** 폼 상태 — DealInput + 화면 표시용 두 칸(salesLabel · tier2CompanyName — 서버에는 보내지 않는다) */
type FormState = DealInput & { id: number | null; requestId: number | null; salesLabel: string; tier2CompanyName: string };

/** [🔎 아는 영문 찾기] 안내에 쓰는 칸 이름 — 화면 라벨과 같은 말이어야 한다 */
const FIELD_LABEL: Record<KnownField, string> = {
  topicEn: '프로젝트명(영문)',
  projectInfoEn: '프로젝트 정보(영문)',
  endUserEn: '엔드유저(영문)',
  tier2: '제안사',
};

/**
 * 🟡 주요 항목 상자 안의 입력 칸 — **흐린 노란색 바탕** (v2.193.0 · 사용자 요청
 * 「입력 칸 배경을 흐린 노란색으로 해서 구별되게 해줘」). 한 곳에 모아 두어 갈리지 않게 한다.
 */
const KEY_INPUT = 'w-full border border-amber-300 bg-amber-50/70 rounded px-2 py-1.5 text-sm';

/**
 * 같은 상자 안이지만 **선택 입력** 칸 — 위에서 **바탕색만** 뺀 것 (v2.193.2 · 사용자 요청
 * 「선택인 입력 칸은 노란색 배경색 빼줘 — 엔드유저 영문·홈페이지, 프로젝트명 영문」).
 * 노란 바탕 = 「채워야 하는 칸」이라는 뜻이 된다. ⚠둘은 **테두리·여백이 같아야** 하니 같이 고칠 것.
 */
const KEY_INPUT_OPTIONAL = 'w-full border border-amber-300 rounded px-2 py-1.5 text-sm';

/**
 * 새 딜등록 창의 빈 값 — v2.189.0 부터 **승인대기**로 시작한다.
 *
 * ⭐**신청일·만료일을 비워 둔다.** 승인 전에는 인포트렌드에 등록된 것이 아니라 만료일이라는 것이
 *   없다. 종전처럼 오늘+6개월을 미리 적어 두면, 아직 등록도 안 된 건이 「연장 마감 D-180」 으로
 *   보이고 만료 임박 집계에 섞인다. 접수번호를 받아 적는 순간 서버가 그날을 신청일로 보고 채운다.
 * ⚠이미 인포트렌드에 등록을 마치고 **옮겨 적는** 경우에는 상태를 「진행」으로 고르고 신청일을
 *   적으면 된다 — 신청일을 적으면 만료일·연장 마감은 종전대로 자동으로 따라온다.
 */
function emptyForm(vendor: string, empId: string): FormState {
  return {
    id: null,
    requestId: null,
    vendor,
    registrationNo: '',
    projectId: '',
    status: 'Pending',
    appliedDate: '',
    expireDate: '',
    deadlineDate: '',
    closedDate: '',
    tier2: '',
    endUserKo: '',
    endUserEn: '',
    endUserUrl: '',
    projectInfo: '',
    topic: '',
    topicEn: '',
    projectInfoEn: '',
    pn: '',
    items: [],
    newUpdate: '',
    remark: '',
    application: '',
    empId,
    ownerName: '',
    note: '',
    amountUsd: '',
    salesId: '',
    salesLabel: '',
    tier2CompanyId: null,
    tier2CompanyName: '',
    tier2ContactId: null,
  };
}

function formOf(r: DealRow): FormState {
  return {
    id: r.id,
    requestId: null,
    rowVer: r.rowVer,
    vendor: r.vendor,
    registrationNo: r.registrationNo,
    projectId: r.projectId,
    status: r.status,
    appliedDate: r.appliedDate ?? '',
    expireDate: r.expireDate ?? '',
    deadlineDate: r.deadlineDate ?? '',
    closedDate: r.closedDate ?? '',
    tier2: r.tier2,
    endUserKo: r.endUserKo,
    endUserEn: r.endUserEn,
    endUserUrl: r.endUserUrl,
    projectInfo: r.projectInfo,
    topic: r.topic,
    topicEn: r.topicEn,
    projectInfoEn: r.projectInfoEn,
    pn: r.pn,
    // 품목 줄이 아직 없는 딜(옛 자료)은 빈 목록으로 연다 — 사람이 채우면 그때부터 표가 원본이 된다
    items: r.items ?? [],
    // 새 업데이트 칸은 **항상 빈 채로 연다** — 창을 열 때마다 지난 글이 다시 실려 오면 같은 글이 두 번 쌓인다
    newUpdate: '',
    remark: r.remark,
    application: r.application,
    empId: r.empId,
    ownerName: r.ownerName,
    note: r.note,
    amountUsd: r.amountUsd === null ? '' : String(r.amountUsd),
    salesId: r.salesId,
    salesLabel: r.salesId ? `${r.salesId}${r.salesProject ? ' · ' + r.salesProject : ''}` : '',
    tier2CompanyId: r.tier2CompanyId,
    tier2CompanyName: r.tier2CompanyName,
    tier2ContactId: r.tier2ContactId,
  };
}

const OTHER_APP = '__other__';

type RequestDialogState = { initial: Partial<DealRequestInput>; dealId: number | null };

/* ── 표 칸 정의 — 📐 내 표 설정 · 정렬 · 필터 (v2.144.0 · 영업진행·매입관리와 같은 방식) ──
 *   defaultOn=true 인 칸이 새 사용자에게 보이는 기본 표다. 기본 표는 1280 에서 가로 스크롤이 안 나게 **한 칸에 두 줄**로 접은
 *   칸(번호 · 기간)을 쓰고, 낱개 칸(접수번호 · Project ID · 신청일 · 만료일 …)은 꺼 둔 채로 두었다 — 원하는 사람이 켠다.
 *   defaultWidthPx 는 사람이 너비를 안 정했을 때의 비례 힌트(ColumnHeader 가 width 만 주고 minWidth 는 안 준다 → 화면 폭 따라 비례).
 *   ✉ 칸도 표 칸이다(발송일이 값) — 정렬·필터로 「안내 안 보낸 딜」을 골라낼 수 있다. */
type DealColumn = Column<DealRow> & {
  defaultOn: boolean;
  toggleLabel?: string;
  defaultWidthPx?: number;
  /** td 클래스 — 긴 글 칸은 max-w-0 로 「남는 폭」만 받는다 */
  cellClass?: string;
};

interface DealColumnCtx {
  mailBusyId: number | null;
  onMail: (r: DealRow) => void;
  /** 상태 칸 드롭다운 (v2.215.0) — 없으면 배지만(정렬·필터 계산용 칸 정의) */
  statusBusyId?: number | null;
  onStatus?: (r: DealRow, s: DealStatus) => void;
}

// 정렬 차례 — ⭐**여덟 가지를 다 적어야 한다**(빠진 상태는 indexOf 가 -1 이라 맨 앞으로 몰린다)
const STATUS_ORDER: DealStatus[] = ['Pending', 'On-going', 'Extend', 'Processing', 'Won', 'Lost', 'Invalid', 'Rejected'];
const dash = (s: string | null | undefined): string => (s && s.trim() ? s : '-');

/** 딜 금액(USD) — 「$418,448」. 소수가 있으면 두 자리까지 (v2.145.0) */
const fmtUsd = (n: number): string => {
  const frac = Number.isInteger(n) ? 0 : 2;
  return `$${n.toLocaleString('en-US', { minimumFractionDigits: frac, maximumFractionDigits: frac })}`;
};
const firstLine = (s: string): string => s.split('\n')[0]?.trim() ?? '';

function buildDealColumns(ctx: DealColumnCtx): DealColumn[] {
  return [
    {
      // 머리글은 두 줄로 접힌다(nowrap 아님) — 한 줄이면 1280 에서 이 칸이 146px 를 먹어 제안사·엔드유저 칸이 좁아졌다(실측)
      key: 'ids', label: '접수번호 / Project ID', toggleLabel: '번호 (접수번호 + Project ID · 두 줄)', type: 'text', defaultOn: true, defaultWidthPx: 132,
      accessor: (r) => r.registrationNo || r.projectId,
      render: (r) => (
        <>
          {/* 번호는 줄이면 안 된다 — 안쪽 상자에 max-w 를 줘서 「MBC (CGNTV) / www…」 같은 긴 글자만 잘린다 */}
          <div className="font-semibold text-slate-800 tabular-nums truncate max-w-[120px]" title={r.registrationNo}>{r.registrationNo || '-'}</div>
          <div className="text-slate-500 tabular-nums truncate max-w-[120px]" title={r.projectId}>{r.projectId || '-'}</div>
        </>
      ),
    },
    { key: 'registrationNo', label: '접수번호', type: 'text', defaultOn: false, defaultWidthPx: 120, nowrapHeader: true, accessor: (r) => r.registrationNo, render: (r) => <span className="tabular-nums whitespace-nowrap">{dash(r.registrationNo)}</span> },
    { key: 'projectId', label: 'Project ID', type: 'text', defaultOn: false, defaultWidthPx: 120, nowrapHeader: true, accessor: (r) => r.projectId, render: (r) => <span className="tabular-nums whitespace-nowrap">{dash(r.projectId)}</span> },
    {
      key: 'status', label: '상태', type: 'text', align: 'center', defaultOn: true, defaultWidthPx: 78, nowrapHeader: true,
      accessor: (r) => r.status,
      // 정렬은 글자순이 아니라 진행 → 종료 순(On-going · Extend · Processing · Won · Lost · Invalid)
      sortAccessor: (r) => STATUS_ORDER.indexOf(r.status),
      // 인포트렌드 여섯 가지는 **그쪽 이름 그대로** 보여 준다(대만과 같은 말을 쓰려고).
      // 우리가 만든 두 가지(승인대기·거절)는 영문 이름이 아무 뜻도 없으니 한글로 (v2.189.0).
      // ⭐v2.215.0 — 누르면 드롭다운으로 바로 바꾼다(사용자: 「목록에서 그 상태 클릭하면 드롭박스로 · 편하게」)
      render: (r) => (ctx.onStatus ? (
        <DealStatusSelect row={r} busy={ctx.statusBusyId === r.id} onChange={(s) => ctx.onStatus?.(r, s)} />
      ) : (
        <span className={`inline-block px-1.5 py-0.5 rounded font-semibold ${STATUS_BADGE[r.status] ?? 'bg-slate-100'}`}>
          {statusShort(r.status)}
        </span>
      )),
    },
    {
      key: 'dates', label: '신청일 / 만료일', toggleLabel: '기간 (신청일 + 만료일 · 두 줄)', type: 'date', defaultOn: true, defaultWidthPx: 96,
      accessor: (r) => r.appliedDate,
      render: (r) => (
        <div className="whitespace-nowrap tabular-nums">
          <div>{r.appliedDate ?? '-'}</div>
          <div className="text-slate-500">{r.expireDate ?? '-'}</div>
        </div>
      ),
    },
    { key: 'appliedDate', label: '신청일', type: 'date', defaultOn: false, defaultWidthPx: 96, nowrapHeader: true, accessor: (r) => r.appliedDate, render: (r) => <span className="tabular-nums whitespace-nowrap">{r.appliedDate ?? '-'}</span> },
    { key: 'expireDate', label: '만료일', type: 'date', defaultOn: false, defaultWidthPx: 96, nowrapHeader: true, accessor: (r) => r.expireDate, render: (r) => <span className="tabular-nums whitespace-nowrap">{r.expireDate ?? '-'}</span> },
    {
      key: 'deadlineDate', label: '연장 마감', type: 'date', defaultOn: true, defaultWidthPx: 100, nowrapHeader: true,
      accessor: (r) => r.deadlineDate,
      render: (r) => {
        const dd = ddayText(r);
        return (
          <div className="whitespace-nowrap tabular-nums">
            <div>{r.deadlineDate ?? '-'}</div>
            {dd ? <span className={`inline-block px-1.5 rounded text-xs font-semibold ${dd.cls}`}>{dd.text}</span> : null}
          </div>
        );
      },
    },
    {
      key: 'dday', label: 'D-day', type: 'number', align: 'right', defaultOn: false, defaultWidthPx: 72, nowrapHeader: true,
      // 종료된 딜은 값이 없다(정렬에서 0 으로 취급)
      accessor: (r) => (r.isClosed ? null : r.dday),
      render: (r) => { const dd = ddayText(r); return dd ? <span className={`inline-block px-1.5 rounded text-xs font-semibold ${dd.cls}`}>{dd.text}</span> : <span className="text-slate-400">-</span>; },
    },
    {
      key: 'tier2', label: '제안사 (Tier 2)', type: 'text', defaultOn: true, defaultWidthPx: 170, cellClass: 'max-w-0',
      // 연결된 거래처 이름을 먼저, 없으면 제안사 메모 글자 (v2.143.0). 둘째 줄은 주소록 담당자
      accessor: (r) => dealCompanyLabel(r),
      render: (r) => (
        <>
          <div className="truncate" title={r.tier2}>{dealCompanyLabel(r) || '-'}</div>
          {r.tier2ContactName ? <div className="truncate text-slate-500" title={r.tier2ContactEmail}>{r.tier2ContactName}</div> : null}
        </>
      ),
    },
    {
      key: 'tier2Contact', label: '제안사 담당자', type: 'text', defaultOn: false, defaultWidthPx: 160, cellClass: 'max-w-0',
      accessor: (r) => r.tier2ContactName,
      render: (r) => (
        <div className="truncate" title={r.tier2ContactEmail}>
          {dash(r.tier2ContactName)}{r.tier2ContactEmail ? <span className="text-slate-500"> · {r.tier2ContactEmail}</span> : null}
        </div>
      ),
    },
    { key: 'endUser', label: '엔드유저', type: 'text', defaultOn: true, defaultWidthPx: 190, cellClass: 'max-w-0', accessor: (r) => dealEndUser(r), render: (r) => <div className={`truncate ${dealEndUser(r) ? 'cell-link' : ''}`} title={r.endUser}>{dealEndUser(r) || '-'}</div> },
    {
      key: 'project', label: '프로젝트', type: 'text', defaultOn: true, defaultWidthPx: 360, cellClass: 'max-w-0',
      accessor: (r) => dealTopic(r),
      render: (r) => {
        const title = dealTopic(r);
        const spec = specLine(r.projectInfo, r.pn);
        return (
          <>
            <div className="truncate text-slate-800" title={title}>{title || '-'}</div>
            {spec ? <div className="truncate text-slate-500" title={spec}>{spec}</div> : null}
          </>
        );
      },
    },
    {
      // 엑셀 「비고」에 $#,##0 서식으로 적혀 있던 딜 금액을 v2.145.0 에서 제 칸으로 뺐다 — 정렬·필터·합계가 된다
      key: 'amountUsd', label: '금액(USD)', toggleLabel: '금액 (USD · 엑셀 「비고」에 있던 값)',
      type: 'number', align: 'right', defaultOn: true, defaultWidthPx: 88, nowrapHeader: true,
      accessor: (r) => r.amountUsd,
      render: (r) => (r.amountUsd === null
        ? <span className="text-slate-400">-</span>
        : <span className="tabular-nums whitespace-nowrap">{fmtUsd(r.amountUsd)}</span>),
    },
    { key: 'pn', label: 'P/N', type: 'text', defaultOn: false, defaultWidthPx: 160, cellClass: 'max-w-0', accessor: (r) => firstLine(r.pn), render: (r) => <div className="truncate" title={r.pn}>{dash(firstLine(r.pn))}</div> },
    { key: 'application', label: '애플리케이션', type: 'text', defaultOn: false, defaultWidthPx: 130, cellClass: 'max-w-0', accessor: (r) => r.application, render: (r) => <div className="truncate" title={r.application}>{dash(r.application)}</div> },
    { key: 'owner', label: '담당자', type: 'text', defaultOn: true, defaultWidthPx: 64, nowrapHeader: true, accessor: (r) => r.ownerName, render: (r) => <div className="truncate max-w-[64px]" title={r.ownerName}>{dash(r.ownerName)}</div> },
    {
      // ⭐v2.306.0 — 사람이 마지막으로 **실제로 바꾼** 것(언제·누가·무엇을). 「최근 갱신」은 저장을 누른 날이라 안 고쳐도 바뀐다.
      //   권애영 님(챗봇 대화 #71 · 10-26): 「상태를 안 바꾸고 내용만 고치면 실제 변경 유무를 알 수가 없어요」.
      //   값(accessor)은 「시각 이름 칸들」 — 정렬하면 최근에 바뀐 딜이 위로, 🔍 에 이름·칸 이름을 적어 거를 수 있다.
      key: 'lastChange', label: '최근 변경', toggleLabel: '최근 변경 (언제·누가·무엇을 · 두 줄)', type: 'text', defaultOn: true, defaultWidthPx: 116,
      // 「● 10-27 황재상」이 한 줄에 들어갈 만큼은 지킨다(1280 실측 · 안 주면 남는 폭만 받아 64px 로 잘렸다) — 둘째 줄(바뀐 칸)은 말줄임
      cellClass: 'max-w-0 min-w-[100px]',
      accessor: (r) => lastChangeText(r.lastChange),
      render: (r) => <LastChangeCell c={r.lastChange} />,
    },
    {
      key: 'sales', label: '영업진행', type: 'text', defaultOn: false, defaultWidthPx: 160, nowrapHeader: true, cellClass: 'max-w-0',
      accessor: (r) => r.salesId,
      render: (r) => (r.salesId
        ? <div className="truncate tabular-nums" title={r.salesProject}>{r.salesId}{r.salesProject ? <span className="text-slate-500"> · {r.salesProject}</span> : null}</div>
        : <span className="text-slate-400">-</span>),
    },
    { key: 'lastUpdate', label: '최근 갱신', type: 'date', defaultOn: false, defaultWidthPx: 96, nowrapHeader: true, accessor: (r) => r.lastUpdate, render: (r) => <span className="tabular-nums whitespace-nowrap">{r.lastUpdate ?? '-'}</span> },
    { key: 'closedDate', label: '종료일', type: 'date', defaultOn: false, defaultWidthPx: 96, nowrapHeader: true, accessor: (r) => r.closedDate, render: (r) => <span className="tabular-nums whitespace-nowrap">{r.closedDate ?? (r.isClosed ? '-' : '진행 중')}</span> },
    { key: 'infoRequestAt', label: '정보 요청', type: 'date', defaultOn: false, defaultWidthPx: 96, nowrapHeader: true, accessor: (r) => r.infoRequestAt, render: (r) => (r.infoRequestAt ? <span className="tabular-nums whitespace-nowrap">{r.infoRequestAt}</span> : <span className="text-slate-400">-</span>) },
    { key: 'note', label: '비고', type: 'text', defaultOn: false, defaultWidthPx: 140, cellClass: 'max-w-0', accessor: (r) => r.note, render: (r) => <div className="truncate" title={r.note}>{dash(r.note)}</div> },
    { key: 'remark', label: 'Remark', type: 'text', defaultOn: false, defaultWidthPx: 140, cellClass: 'max-w-0', accessor: (r) => firstLine(r.remark), render: (r) => <div className="truncate" title={r.remark}>{dash(firstLine(r.remark))}</div> },
    {
      key: 'expiryMail', label: '✉', toggleLabel: '✉ 만료 안내 메일 (발송일)', type: 'date', align: 'center', defaultOn: true, defaultWidthPx: 44, nowrapHeader: true,
      accessor: (r) => r.expiryNoticeAt,
      render: (r) => {
        if (r.isClosed) return null;
        // 승인대기 건에는 만료일이 없다 — 「만료 안내」를 보낼 것이 없으므로 단추도 내지 않는다 (v2.189.0)
        if (r.status === 'Pending') return null;
        const expiring = isExpiring(r);
        return (
          <div className="whitespace-nowrap">
            <button
              type="button"
              onClick={(ev) => { ev.stopPropagation(); ctx.onMail(r); }}
              disabled={ctx.mailBusyId === r.id}
              title={`${r.expiryNoticeAt ? `마지막 안내 ${r.expiryNoticeAt} · ` : ''}제안사에 만료 안내 메일 보내기`}
              className={`btn btn-sm ${expiring ? 'btn-warning' : 'btn-secondary'}`}
            >
              ✉
            </button>
            {r.expiryNoticeAt ? (
              <div className="text-[11px] text-slate-500 tabular-nums" title={`만료 안내 보낸 날 ${r.expiryNoticeAt}`}>{mmdd(r.expiryNoticeAt)}</div>
            ) : null}
          </div>
        );
      },
    },
  ];
}

/** 정렬·필터 계산용 — 값(accessor)만 쓰므로 ✉ 단추 동작은 필요 없다. 화면에 그리는 칸은 컴포넌트 안에서 ctx 를 넣어 다시 만든다 */
const DEAL_COLUMNS: DealColumn[] = buildDealColumns({ mailBusyId: null, onMail: () => undefined });
const DEAL_ALL_KEYS = DEAL_COLUMNS.map((c) => c.key);
const DEAL_DEFAULT_KEYS = DEAL_COLUMNS.filter((c) => c.defaultOn).map((c) => c.key);
/** 기본 정렬 — 신청일 최신순(접힌 「기간」 칸에 ▼ 가 보이도록 그 칸의 키로) */
const DEFAULT_SORT = [{ key: 'dates', dir: 'desc' as const }];

export function DealRegistrationPage(): React.JSX.Element {
  const qc = useQueryClient();
  const { user } = useAuth();
  const vendor = 'infortrend';
  const [view, setView] = useState<'deals' | 'requests'>('deals');
  const [scope, setScope] = useState<DealScope>('tracking');
  const [year, setYear] = useState<number | null>(null);
  const [q, setQ] = useState('');
  const [qApplied, setQApplied] = useState('');
  const [statusFilter, setStatusFilter] = useState<DealStatus | ''>('');
  const [expiringOnly, setExpiringOnly] = useState(false);
  // 정렬·필터 — 헤더 클릭(다단계) · 돋보기 필터. 같은 세션 안에서는 유지, 기본은 신청일 최신순 (v2.144.0)
  const colState = useColState({ storageKey: 'deal-registration', initialSort: DEFAULT_SORT });
  const [detailId, setDetailId] = useState<number | null>(null);
  const [form, setForm] = useState<FormState | null>(null);
  /**
   * 창을 **열었을 때의** 제안 품목(P/N) — 「본체 경고」를 물어볼지 정하는 기준 (v2.160.0).
   * 기존 딜의 상태만 바꾸는 사람에게 P/N 이야기를 꺼내면 잔소리가 된다 →
   * **새 딜이거나, P/N 칸을 실제로 건드렸을 때만** 물어본다.
   */
  const pnBaselineRef = useRef<string>('');
  /** ✏ 만료 안내 문구 창 (v2.147.0) */
  const [templateOpen, setTemplateOpen] = useState(false);
  /** 📦 종료 탭으로 넘기기 창 (v2.215.0) */
  const [archiveOpen, setArchiveOpen] = useState(false);
  /** 🔍 가격표에서 제안 품목 찾기 (v2.151.0) — 등록/수정 창의 P/N 칸 아래 패널 */
  const [pnPickOpen, setPnPickOpen] = useState(false);
  const [pnQuery, setPnQuery] = useState('');
  const [pnRows, setPnRows] = useState<InfortrendSearchRow[]>([]);
  const [pnBusy, setPnBusy] = useState(false);
  const [pnErr, setPnErr] = useState('');
  /** 현재 분기에 없어 옛 분기까지 뒤졌나 */
  const [pnOldQuarter, setPnOldQuarter] = useState(false);
  /** 골랐을 때 P/N 칸에 무엇을 넣을지 */
  const [pnInsert, setPnInsert] = useState<'pnName' | 'model' | 'pn' | 'modelDesc'>('pnName');
  /** 어느 묶음을 보고 있나 — ① 본체(기본) → ② 호스트보드 → ③ 하드디스크 → ④ 기타 (v2.152.0) */
  const [pnGroup, setPnGroup] = useState<PartGroup['key']>('main');
  /** 그 묶음 안에서 고른 제품군(가격표 시트). 빈 값 = 전체 */
  const [pnCat, setPnCat] = useState('');
  const [formError, setFormError] = useState('');
  const [appOther, setAppOther] = useState(false);
  const [lastByYear, setLastByYear] = useState<{ year: number | null; count: number }[]>([]);
  const [mailBusyId, setMailBusyId] = useState<number | null>(null);
  /** ✨ 영문 채우는 중 (v2.191.0) — 모델을 부르는 동안 몇 초 걸린다 */
  const [transBusy, setTransBusy] = useState(false);
  const [notice, setNotice] = useState('');
  const [showLinked, setShowLinked] = useState(false);
  const [reqDialog, setReqDialog] = useState<RequestDialogState | null>(null);
  /** 주소로 열어 달라는 딜(`?deal=번호`) — 지금 목록에 없어도 상세를 띄우려고 따로 받아 둔다 (v2.142.0 대시보드에서 옴) */
  const [detailOverride, setDetailOverride] = useState<DealRow | null>(null);
  const [searchParams, setSearchParams] = useSearchParams();

  // 검색은 300ms 뒤에 보낸다 — 한 글자마다 서버를 부르지 않게
  useEffect(() => {
    const t = setTimeout(() => setQApplied(q.trim()), 300);
    return () => clearTimeout(t);
  }, [q]);

  /**
   * 대시보드 딥링크 (v2.142.0) — `?expiring=1` 은 [⏰ 만료 임박] 을 켠 채로, `?deal=번호` 는 그 딜의 상세를 연 채로 뜬다.
   * 한 번 읽고 주소에서 지운다(새로고침마다 같은 창이 또 뜨지 않게). 검사 그물 check:menu ⑨가 보내는 쪽과 대조한다.
   */
  useEffect(() => {
    const wantExpiring = searchParams.get('expiring') === '1';
    const dealParam = searchParams.get('deal');
    if (!wantExpiring && !dealParam) return;
    if (wantExpiring) { setView('deals'); setScope('tracking'); setExpiringOnly(true); colState.setSort('deadlineDate', 'asc'); }
    const dealId = dealParam ? Number(dealParam) : 0;
    if (dealId > 0) {
      getDeal(dealId)
        .then((row) => { setDetailOverride(row); setDetailId(row.id); })
        .catch((e: Error) => setNotice(`⚠ 딜등록 #${dealId} 을 열지 못했습니다 — ${e.message}`));
    }
    const next = new URLSearchParams(searchParams);
    next.delete('expiring');
    next.delete('deal');
    setSearchParams(next, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  const meta = useQuery({ queryKey: ['dealMeta'], queryFn: getDealMeta, staleTime: 5 * 60_000 });
  const list = useQuery({
    queryKey: ['deals', vendor, scope, year, qApplied, statusFilter],
    queryFn: () => listDeals({ vendor, scope, year: scope === 'closed' ? year : null, q: qApplied, status: statusFilter }),
    staleTime: 15_000,
  });
  // 제안사 담당자 후보 = 거래처 담당자 주소록 (v2.143.0). 키는 거래처 관리 탭과 같게 두어 한쪽에서 고치면 다른 쪽도 새로 읽는다
  const contacts = useQuery({ queryKey: ['partnerContacts', false], queryFn: () => listContacts(), staleTime: 60_000 });
  const companies = useQuery({ queryKey: ['partnerContactCompanies'], queryFn: listContactCompanies, staleTime: 5 * 60_000 });
  const contactRows = contacts.data?.rows ?? [];
  const [pickerOpen, setPickerOpen] = useState(false);
  const [newContact, setNewContact] = useState<PartnerContactInput | null>(null);
  const [newContactError, setNewContactError] = useState('');
  const requests = useQuery({
    queryKey: ['dealRequests', vendor, showLinked],
    queryFn: () => listRequests(showLinked ? 'all' : 'no', vendor),
    staleTime: 15_000,
  });

  // 연도 칩은 어느 조회에서든 같이 온다(벤더 전체 기준) — 종료 탭으로 넘어갈 때 최근 연도를 기본으로 고른다
  useEffect(() => {
    if (list.data) setLastByYear(list.data.counts.byYear);
  }, [list.data]);

  const fetched = list.data?.rows ?? [];
  /* [⏰ 만료 임박] = **24일 검토 표 · 25일 엑셀에 나갈 딜 그대로** (v2.215.0 · isMonthlyReviewRow) —
     진행 중 탭 · 승인대기 아님 · 연장 마감 30일 안(지난 것 포함) · 넘기기 전 실주·무효도 들어간다. */
  const expiringCount = useMemo(() => fetched.filter(isMonthlyReviewRow).length, [fetched]);
  /** [📦 종료 탭으로 넘기기] 단추의 숫자 — 진행 중 탭에 남은 종료 상태 딜 (서버가 센다) */
  const archiveCands = useQuery({
    queryKey: ['deals', 'archive-candidates', vendor],
    queryFn: () => listArchiveCandidates(vendor),
    enabled: view === 'deals' && scope === 'tracking',
    staleTime: 15_000,
  });
  const archiveCount = archiveCands.data?.length ?? 0;

  /** 헤더 정렬·필터를 걸기 전의 행 — [⏰ 만료 임박] 까지 적용된 것. 필터 팝오버의 목록은 여기서 뽑는다 */
  const baseRows = useMemo(
    () => (scope === 'tracking' && expiringOnly ? fetched.filter(isMonthlyReviewRow) : fetched),
    [fetched, scope, expiringOnly],
  );
  // 헤더 정렬(다단계)·필터 — 숨긴 칸의 정렬·필터도 걸리도록 전체 칸 정의로 계산한다 (영업진행과 같은 규칙)
  const rows = useMemo(
    () => applyColState(baseRows, DEAL_COLUMNS, colState),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [baseRows, colState.sortStack, colState.filters],
  );

  /** 지금 보이는 줄의 금액(USD) 합계 — 안 적힌 줄은 빼고 센다 (v2.145.0) */
  const amountSum = useMemo(() => {
    let sum = 0; let n = 0;
    for (const r of rows) if (r.amountUsd !== null) { sum += r.amountUsd; n += 1; }
    return { sum, n };
  }, [rows]);

  const detail = useMemo(
    () => fetched.find((r) => r.id === detailId) ?? (detailOverride && detailOverride.id === detailId ? detailOverride : null),
    [fetched, detailId, detailOverride],
  );

  const refresh = (): void => {
    void qc.invalidateQueries({ queryKey: ['deals'] });
    void qc.invalidateQueries({ queryKey: ['dealRequests'] });
    void qc.invalidateQueries({ queryKey: ['partnerContacts'] });
  };

  const create = useMutation({
    mutationFn: (input: DealInput) => createDeal(input),
    onSuccess: (row) => { setForm(null); refresh(); setView('deals'); setDetailId(row.id); },
    onError: (e: Error) => setFormError(e.message),
  });
  const update = useMutation({
    mutationFn: ({ id, input }: { id: number; input: DealInput }) => updateDeal(id, input),
    onSuccess: () => { setForm(null); refresh(); },
    onError: (e: Error) => setFormError(e.message),
  });
  const remove = useMutation({
    mutationFn: (id: number) => deleteDeal(id),
    onSuccess: () => { setDetailId(null); refresh(); },
    onError: (e: Error) => window.alert(`삭제하지 못했습니다 — ${e.message}`),
  });
  const removeRequest = useMutation({
    mutationFn: (id: number) => deleteRequest(id),
    onSuccess: refresh,
    onError: (e: Error) => window.alert(`지우지 못했습니다 — ${e.message}`),
  });
  /* 📝 프로젝트 정보 업데이트 이력 (v2.194.0) — 상세 창에서 바로 넣고·고치고·지운다.
     서버가 고친 딜을 통째로 돌려주므로 refresh 로 화면이 따라온다. */
  const addUpdate = useMutation({
    mutationFn: ({ id, body }: { id: number; body: string }) => addDealUpdate(id, body),
    onSuccess: refresh,
    onError: (e: Error) => window.alert(`업데이트를 넣지 못했습니다 — ${e.message}`),
  });
  const editUpdate = useMutation({
    mutationFn: ({ id, updateId, body, date }: { id: number; updateId: number; body: string; date?: string }) =>
      editDealUpdate(id, updateId, body, date),
    onSuccess: refresh,
    onError: (e: Error) => window.alert(`업데이트를 고치지 못했습니다 — ${e.message}`),
  });
  const removeUpdate = useMutation({
    mutationFn: ({ id, updateId }: { id: number; updateId: number }) => removeDealUpdate(id, updateId),
    onSuccess: refresh,
    onError: (e: Error) => window.alert(`업데이트를 지우지 못했습니다 — ${e.message}`),
  });
  /* 🔽 상태 칸 드롭다운 (v2.215.0) — 고르면 바로 저장. 종료로 바꿔도 **진행 중 탭에 남는다**는 것을 한 줄로 알려 준다
     (예전엔 종료로 바꾸면 목록에서 사라졌다 — 바뀐 동작을 처음 겪는 사람이 「안 바뀌었나?」 하지 않게). */
  const setStatus = useMutation({
    mutationFn: ({ id, status }: { id: number; status: DealStatus }) => setDealStatus(id, status),
    onSuccess: (row) => {
      refresh();
      const who = [row.registrationNo, dealEndUser(row)].filter(Boolean).join(' · ') || `#${row.id}`;
      // ⚠상태 이름 뒤에 조사를 붙이지 않는다 — 「On-going 로」 처럼 틀린다(영문·한글 받침이 제각각)
      setNotice(row.isClosed && !row.archived
        ? `상태 바꿈 — ${who} → ${statusShort(row.status)}. 진행 중 탭에 그대로 두었습니다(종료 탭으로는 [📦 종료 탭으로 넘기기]).`
        : `상태 바꿈 — ${who} → ${statusShort(row.status)}.`);
    },
    onError: (e: Error) => window.alert(`상태를 바꾸지 못했습니다 — ${e.message}`),
  });
  const statusBusyId = setStatus.isPending ? (setStatus.variables?.id ?? null) : null;
  const saving = create.isPending || update.isPending;

  const switchScope = (s: DealScope): void => {
    setView('deals');
    setScope(s);
    setStatusFilter('');
    setExpiringOnly(false);
    if (s === 'closed') setYear(lastByYear[0]?.year ?? null);
  };

  const toggleExpiring = (): void => {
    const next = !expiringOnly;
    setExpiringOnly(next);
    if (next) colState.setSort('deadlineDate', 'asc');
  };

  const myEmpId = (): string =>
    user?.empId && meta.data?.employees.some((e) => e.empId === user.empId) ? user.empId : '';

  const openNew = (): void => {
    if (!meta.data) return;
    setFormError('');
    setAppOther(false);
    // 담당자는 기본으로 나(직원 표에 있는 계정이면)
    pnBaselineRef.current = '';
    setForm(emptyForm(vendor, myEmpId()));
  };
  /** 회신이 온 정보 요청 → 새 딜등록 창을 그 내용으로 채워 연다. 넣으면 서버가 요청과 연결한다 */
  const openNewFromRequest = (r: DealRequestRow): void => {
    if (!meta.data) return;
    setFormError('');
    setAppOther(false);
    const base = emptyForm(vendor, myEmpId());
    const tier2 = [r.company, [r.contactName, r.toEmails.join(' ')].filter(Boolean).join(' ')].filter(Boolean).join(' / ');
    // 프로젝트명은 v2.189.0 부터 **제 칸(topic)** 으로 간다 — 글 안에 「1. Project Name :」 로 섞지 않는다
    const info = r.projectStatus ? `2. Project Information : ${r.projectStatus}` : '';
    // 요청을 보낸 주소록 담당자가 있으면 그 사람·회사로 연결까지 미리 채운다 (v2.143.0)
    const c = r.contactId ? contactRows.find((x) => x.id === r.contactId) ?? null : null;
    pnBaselineRef.current = itemsText(base);
    setForm({
      // ⭐엔드유저 세 칸은 **서버가 갈라서 준다**(v2.193.0) — 가르는 규칙을 화면에 또 적지 않는다
      ...base,
      requestId: r.id,
      tier2,
      endUserKo: r.endUserKo,
      endUserEn: r.endUserEn,
      endUserUrl: r.endUserUrl,
      projectInfo: info,
      topic: r.projectName,
      tier2ContactId: c?.id ?? null, tier2CompanyId: c?.partnerCompanyId ?? null, tier2CompanyName: c ? c.companyName : '',
    });
  };
  const openEdit = (r: DealRow): void => {
    if (!meta.data) return;
    setFormError('');
    const f = formOf(r);
    const known = meta.data.applications.some((g) => g.items.includes(f.application));
    setAppOther(!!f.application && !known);
    pnBaselineRef.current = itemsText(f);
    setForm(f);
  };
  const askDelete = (r: DealRow): void => {
    const label = r.registrationNo || r.projectId || `#${r.id}`;
    if (!window.confirm(`딜등록 「${label}」 을(를) 지울까요?\n지운 뒤에는 변경 이력에서만 되돌릴 수 있습니다.`)) return;
    remove.mutate(r.id);
  };
  const askDeleteRequest = (r: DealRequestRow): void => {
    if (!window.confirm(`「${r.company || r.toEmails.join(', ')}」 에 보낸 정보 요청 기록을 지울까요?\n(보낸 메일이 취소되는 것은 아닙니다)`)) return;
    removeRequest.mutate(r.id);
  };

  /** ✉ 정보 요청 창 — 빈 채로 / 기존 딜 / 보낸 요청(다시 보내기)에서 연다 */
  const openRequestBlank = (): void => setReqDialog({ initial: {}, dealId: null });
  /* ⛔「기존 딜에서 정보 요청 열기」는 v2.193.2 에서 없앴다 — 상세 화면의 그 단추를 뺐기 때문(부르는 곳 0). */
  const openRequestAgain = (r: DealRequestRow): void =>
    setReqDialog({
      initial: {
        contactId: r.contactId, company: r.company, contactName: r.contactName, email: r.toEmails[0] ?? '',
        endUser: r.endUser, projectName: r.projectName, projectStatus: r.projectStatus,
      },
      dealId: r.dealId,
    });

  /**
   * ✉ 만료 안내 메일 — 서버가 채운 초안으로 메일 창을 연다. 보내고 나면(onSent) 딜에 발송일을 적는다.
   * ⚠발송 자체는 메일 창이 한다 — 여기서는 「열어 주기」와 「나갔다고 적기」만.
   */
  const sendExpiryMail = async (r: DealRow): Promise<void> => {
    if (r.expiryNoticeAt && !window.confirm(`이 딜은 ${r.expiryNoticeAt} 에 만료 안내를 보냈습니다.\n다시 보낼까요?`)) return;
    setMailBusyId(r.id);
    setNotice('');
    try {
      const draft = await getExpiryMailDraft(r.id);
      if (draft.to.length === 0) {
        setNotice('⚠ 제안사 담당자 메일을 찾지 못했습니다(주소록 담당자도, 제안사 메모의 주소도 없음) — 메일 창에서 받는사람을 직접 적어 주세요.');
      }
      openMailCompose({
        to: draft.to,
        subject: mailSubject('딜등록 만료 안내', draft.subjectName),
        body: draft.body,
        onSent: (res) => {
          markExpiryMailSent(r.id, res.to)
            .then(() => { setNotice(`✉ ${r.projectId || r.registrationNo} 만료 안내를 보냈습니다 — 발송일을 적어 두었습니다.`); refresh(); })
            .catch((e: Error) => window.alert(`메일은 나갔지만 발송 기록을 적지 못했습니다 — ${e.message}`));
        },
      });
    } catch (e) {
      window.alert(`메일 초안을 만들지 못했습니다 — ${(e as Error).message}`);
    } finally {
      setMailBusyId(null);
    }
  };

  /**
   * ✉ 딜등록 안내 메일 (v2.190.0) — 인포트렌드(한/영) · 제안사(한글). 내용이 서로 다르다.
   *
   * ⭐**못 보내는 이유를 서버가 문장으로 준다**(`blocked`). 단추를 조용히 감추지 않고 그 문장을
   *   그대로 보여 준다 — 「왜 안 되지」로 문의가 오지 않게.
   * ⚠참조의 sales@ 는 여기서 안 넣는다. 서버가 나가는 모든 메일에 이미 넣는다.
   */
  const sendNoticeMail = async (r: DealRow, target: NoticeTarget): Promise<void> => {
    setMailBusyId(r.id);
    setNotice('');
    try {
      const draft = await getNoticeMailDraft(r.id, target);
      if (draft.blocked) {
        window.alert(`아직 안내 메일을 보낼 수 없습니다.\n\n${draft.blocked}`);
        return;
      }
      openMailCompose({
        to: draft.to,
        cc: draft.cc,
        subject: mailSubject('딜등록 안내', draft.subjectName),
        bodyDoc: draft.doc,
      });
    } catch (e) {
      window.alert(`메일 초안을 만들지 못했습니다 — ${(e as Error).message}`);
    } finally {
      setMailBusyId(null);
    }
  };

  /**
   * 🔎 아는 영문 찾기 (v2.192.0 · 종전 「✨ 영문 채우기」) — **번역하지 않는다.**
   *
   * ⭐우리가 **과거 딜에 적어 둔 영문**과 **이 딜 자기 글에 이미 있는 영문**만 찾아 칸에 넣는다.
   * ⛔**모르는 문장은 비워 둔다** — 지어내지 않고 「직접 적어 주세요」라고 말한다.
   *   (단추 이름을 「영문 채우기」에서 바꾼 이유가 이것이다 — 다 해 준다는 뜻이 되면 안 된다.)
   * ⭐**저장하지 않는다.** 보고 고친 뒤 [고치기] 를 눌러야 저장된다.
   * ⚠서버는 **비어 있는 칸만** 돌려준다. 손으로 적어 둔 글은 덮이지 않으므로 묻지 않는다.
   */
  const fillEnglish = async (cur: FormState): Promise<void> => {
    if (!cur.id) {
      window.alert('먼저 저장한 뒤에 눌러 주세요 — 서버가 과거 딜의 표기를 함께 뒤집니다.');
      return;
    }
    setTransBusy(true);
    try {
      const r = await findKnownEnglish(cur.id);
      setForm((f) => {
        if (!f) return f;
        const patch: Partial<FormState> = {};
        for (const x of r.filled) patch[x.label] = x.value;
        return { ...f, ...patch };
      });
      const got = r.filled.map((x) => `${FIELD_LABEL[x.label]} ← ${x.how}`).join(' · ');
      const hint = r.hints.map((h) => `${h.ko} = ${h.en}`).join(' · ');
      const parts: string[] = [];
      if (got) parts.push(`🔎 찾았습니다 — ${got}. 확인하고 [고치기] 를 눌러 저장하세요.`);
      if (hint) parts.push(`💡 글 안에서 아는 이름 — ${hint}`);
      if (r.missing.length > 0) parts.push(`✍ 모르는 곳은 비워 뒀습니다 — ${r.missing.join(' · ')} 은 직접 적어 주세요.`);
      if (parts.length === 0) parts.push(`아는 영문이 없었습니다 — 직접 적어 주세요. (과거 딜 이름 ${r.dictSize}개를 뒤졌습니다)`);
      // 한 줄 안내라 마디를 눈에 띄게 갈라 준다 — 안 그러면 세 문장이 이어 붙어 읽기 어렵다
      setNotice(parts.join('   |   '));
    } catch (e) {
      window.alert(`아는 영문을 찾지 못했습니다 — ${(e as Error).message}`);
    } finally {
      setTransBusy(false);
    }
  };

  /* ── 🔔 시험발송은 v2.215.0 부터 [🔔 월간 안내 ▼] 메뉴(DealMonthlyNoticeMenu)가 한다 — 20일·24일·25일 차례를 골라서 ── */

  /* ── 🔍 가격표에서 제안 품목 찾기 (v2.151.0) ──
   *   사용자 요청: 「딜등록 항목 부분이 인포트렌드 가격표 목록에서 검색어로 매칭돼 들어가게」.
   *   ⚠고르기는 **거들 뿐**이다 — P/N 칸은 자유 입력 그대로 둔다. 운영 딜에는 가격표 어느 분기에도
   *   없는 모델(GS3060G2LF)이 실제로 적혀 있다. */
  const formOpen = !!form;
  useEffect(() => {
    // 창을 닫으면 찾기 패널도 접는다. ⚠deps 에 form 객체를 넣으면 글자를 칠 때마다 패널이 닫힌다.
    if (!formOpen) {
      setPnPickOpen(false); setPnQuery(''); setPnRows([]); setPnErr(''); setPnOldQuarter(false);
      setPnGroup('main'); setPnCat('');
    }
  }, [formOpen]);

  /** 묶음·제품군 목록 — 어느 분류가 어느 묶음인지는 **서버가 정한다**(화면에 베끼지 않는다) */
  // 창이 열려 있으면 미리 받아 둔다 — 저장할 때 「본체가 적혀 있나」를 물어봐야 해서
  // 🔍 패널을 한 번도 안 연 사람도 규칙이 있어야 한다 (v2.160.0). 30분 캐시라 부담이 없다.
  const partGroupsQ = useQuery({
    queryKey: ['infortrend-part-groups'],
    queryFn: listPartGroups,
    enabled: formOpen || pnPickOpen,
    staleTime: 30 * 60 * 1000,
  });
  const pnGroups = partGroupsQ.data?.groups ?? [];
  const pnGroupNow = pnGroups.find((g) => g.key === pnGroup);

  useEffect(() => {
    if (!pnPickOpen) return;
    let alive = true;
    setPnBusy(true);
    const t = setTimeout(() => {
      // 검색어가 없어도 묶음·제품군만으로 목록을 본다 (전체를 뒤지면 너무 많다 — v2.152.0)
      searchInfortrendParts(pnQuery, { group: pnGroup, cat: pnCat || undefined, limit: 200 })
        .then((r) => { if (!alive) return; setPnRows(r.rows); setPnOldQuarter(r.searchedAll); setPnErr(''); })
        .catch((e: Error) => { if (!alive) return; setPnRows([]); setPnErr(e.message); })
        .finally(() => { if (alive) setPnBusy(false); });
    }, 300);
    return () => { alive = false; clearTimeout(t); };
  }, [pnPickOpen, pnQuery, pnGroup, pnCat]);

  /**
   * 가격표 한 줄 → P/N 칸에 넣을 글자. P/N 이 여러 줄인 부품은 첫 줄만 쓴다.
   *
   * ⭐**기본은 「P/N (이름)」이다** (v2.177.0 · 2026-09-14 · 사용자 지시:
   *   「P/N 만으로 구분이 안되는 경우가 많아서 기본적으로 P/N 과 모델명을 같이 적어주고,
   *     모델명이 없는 경우 Description 을 모델명 대신 적어줘」).
   *   ⚠가격표 2,196개 P/N 중 **모델명이 있는 것은 14%뿐**이라 대부분 Description 이 이름이 된다
   *     (설명은 전부 차 있고 평균 60자·최대 139자).
   *   ⚠종전 세 가지(모델명·P/N·모델명+설명)는 **그대로 남긴다** — 쓰던 사람이 있다.
   */
  const partText = (r: InfortrendSearchRow): string => {
    const onePn = String(r.pn ?? '').split(/[\r\n]+/)[0]?.trim() ?? '';
    const model = (r.model ?? '').trim();
    const descr = (r.description ?? '').replace(/\s+/g, ' ').trim();
    if (pnInsert === 'pn') return onePn || model;
    if (pnInsert === 'modelDesc') {
      return [model || onePn, descr.slice(0, 80)].filter(Boolean).join(' — ');
    }
    if (pnInsert === 'model') return model || onePn;
    // 'pnName' (기본) — P/N 과 이름을 같이. 이름 = 모델명, 없으면 Description
    const name = model || descr.slice(0, 120);
    if (!onePn) return name;
    return name ? `${onePn}  (${name})` : onePn;
  };

  /** 품목 한 줄 고치기 (v2.178.0) */
  const setItem = (i: number, patch: Partial<DealItem>): void => {
    if (!form) return;
    setForm({ ...form, items: form.items.map((it, j) => (j === i ? { ...it, ...patch } : it)) });
  };

  /** 고른 품목을 **줄로 하나 더** 붙인다 (v2.178.0 — 종전에는 글자 칸 맨 아래에 붙였다) */
  const addPart = (r: InfortrendSearchRow): void => {
    const text = partText(r);
    if (!text || !form) return;
    if (form.items.length >= 200) { setPnErr('품목은 200줄까지 넣을 수 있습니다.'); return; }
    setPnErr('');
    setForm({ ...form, items: [...form.items, { item: text, qty: 1, note: '' }] });
  };

  /** 「본체 필수」 경고가 볼 글자 — 품목 줄을 이어 붙인 것 */
  const itemsText = (f: FormState): string => f.items.map((it) => it.item).filter(Boolean).join('\n');

  /* ── 📐 내 표 설정 — 사용자 환경설정(preferences)에 영구 저장. PC 만 적용 (영업진행·매입관리와 같은 방식 · v2.144.0) ── */
  const prefsQ = useQuery({ queryKey: ['preferences'], queryFn: prefsApi.getPreferences, staleTime: 5 * 60 * 1000 });
  const patchPrefs = useMutation({
    mutationFn: (next: Partial<UserPreferences>) => prefsApi.patchPreferences(next),
    onSuccess: (newPrefs) => qc.setQueryData(['preferences'], newPrefs),
  });
  const [colMenuOpen, setColMenuOpen] = useState(false);
  // excelMode = 편집 모드 깃발(끌기·너비·⚙ 노출). 보이는 칸·순서·너비는 저장된 값이 있으면 켜짐과 무관하게 적용된다
  const excelMode = !!prefsQ.data?.dealTabExcelMode;
  const activeColKeys = useMemo<Set<string>>(
    () => resolveActiveColumns(prefsQ.data?.dealTabColumns, prefsQ.data?.dealTabColumnsKnown, DEAL_ALL_KEYS, DEAL_DEFAULT_KEYS),
    [prefsQ.data],
  );
  const orderedKeys = useMemo<string[]>(() => resolveColumnOrder(prefsQ.data?.dealTabColumnOrder, DEAL_ALL_KEYS), [prefsQ.data]);
  const columnWidths = prefsQ.data?.dealTabColumnWidths;
  const hasPrefs =
    !!prefsQ.data &&
    (!!prefsQ.data.dealTabColumns?.length || !!prefsQ.data.dealTabColumnOrder?.length || !!prefsQ.data.dealTabColumnWidths || !!prefsQ.data.dealTabExcelMode);
  // 화면에 그리는 칸 — ✉ 단추가 이 컴포넌트의 상태(보내는 중)를 알아야 해서 여기서 만든다
  const columns = useMemo(
    () => buildDealColumns({
      mailBusyId,
      onMail: (r) => { void sendExpiryMail(r); },
      statusBusyId,
      onStatus: (r, s) => setStatus.mutate({ id: r.id, status: s }),
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [mailBusyId, statusBusyId],
  );
  const visibleColumns = useMemo<DealColumn[]>(() => {
    const map = new Map(columns.map((c) => [c.key, c]));
    return orderedKeys.filter((k) => activeColKeys.has(k)).map((k) => map.get(k)).filter((c): c is DealColumn => !!c);
  }, [orderedKeys, activeColKeys, columns]);

  function toggleColumn(key: string): void {
    const next = new Set(activeColKeys);
    if (next.has(key)) next.delete(key); else next.add(key);
    patchPrefs.mutate({ dealTabColumns: [...next], dealTabColumnsKnown: [...DEAL_ALL_KEYS] });
  }
  function handleReorder(fromKey: string, toKey: string, position: 'before' | 'after'): void {
    const filtered = orderedKeys.filter((k) => k !== fromKey);
    const idx = filtered.indexOf(toKey);
    if (idx < 0) return;
    filtered.splice(position === 'before' ? idx : idx + 1, 0, fromKey);
    patchPrefs.mutate({ dealTabColumnOrder: filtered });
  }
  function handleMoveLeft(key: string): void {
    const visKeys = visibleColumns.map((c) => c.key);
    const idx = visKeys.indexOf(key);
    const prev = idx > 0 ? visKeys[idx - 1] : undefined;
    if (prev) handleReorder(key, prev, 'before');
  }
  function handleMoveRight(key: string): void {
    const visKeys = visibleColumns.map((c) => c.key);
    const idx = visKeys.indexOf(key);
    const next = idx >= 0 && idx < visKeys.length - 1 ? visKeys[idx + 1] : undefined;
    if (next) handleReorder(key, next, 'after');
  }
  function handleResize(key: string, widthPx: number): void {
    patchPrefs.mutate({ dealTabColumnWidths: { ...(columnWidths ?? {}), [key]: widthPx } });
  }
  function handleExcelModeReset(): void {
    // 저장한 칸·순서·너비 전부 지우기(서버 PATCH 의 null = 키 삭제) + 설정 모드 끄기
    patchPrefs.mutate({
      dealTabExcelMode: false,
      dealTabColumns: null as unknown as undefined,
      dealTabColumnsKnown: null as unknown as undefined,
      dealTabColumnOrder: null as unknown as undefined,
      dealTabColumnWidths: null as unknown as undefined,
    });
  }
  /** [필터·정렬 초기화 ▼] — 기본: 진행 중 탭 · 신청일 최신순 · 검색·필터 없음 / 모두 해제: 지금 탭은 두고 정렬·필터·검색만 지움 */
  const clearListState = (): void => {
    colState.resetAll();
    setQ('');
    setStatusFilter('');
    setExpiringOnly(false);
  };
  const resetToDefault = (): void => {
    clearListState();
    setView('deals');
    setScope('tracking');
    setYear(null);
    colState.setSort(DEFAULT_SORT[0]!.key, DEFAULT_SORT[0]!.dir);
  };

  const rule = meta.data?.rule ?? { expireMonths: 6, deadlineDays: 3 };
  const onApplied = (v: string): void => {
    if (!form) return;
    // 신청일을 바꾸면 만료·마감을 규칙으로 다시 채운다(엑셀 수식과 같은 동작). 그 뒤 손으로 고칠 수 있다.
    const expire = v ? addMonths(v, rule.expireMonths) : form.expireDate;
    const deadline = expire ? addDays(expire, rule.deadlineDays) : form.deadlineDate;
    setForm({ ...form, appliedDate: v, expireDate: expire, deadlineDate: deadline });
  };
  const onExpire = (v: string): void => {
    if (!form) return;
    setForm({ ...form, expireDate: v, deadlineDate: v ? addDays(v, rule.deadlineDays) : form.deadlineDate });
  };
  /** 연장 처리 편의 — 만료일을 6개월 뒤로 (없으면 신청일 기준) · 마감도 따라간다 · 상태는 Extend 로 */
  const extendSixMonths = (): void => {
    if (!form) return;
    const base = form.expireDate || form.appliedDate;
    if (!base) return;
    const expire = addMonths(base, rule.expireMonths);
    setForm({ ...form, expireDate: expire, deadlineDate: addDays(expire, rule.deadlineDays), status: form.status === 'On-going' ? 'Extend' : form.status });
  };
  /* ⛔[＋ 오늘 경과 줄] 단추(addTodayLine)는 v2.194.0 에서 뺐다 —
     경과는 이제 「📝 새 업데이트」 칸에 적고 이력으로 쌓인다(적는 곳을 둘로 두지 않는다). */

  const submit = (): void => {
    if (!form) return;
    setFormError('');
    if (!form.status) { setFormError('상태를 골라 주세요.'); return; }
    /* ⛔「접수번호·Project ID·엔드유저·프로젝트 정보 중 하나는 적어 주세요」 검사는 v2.232.0 에서 뺐다(점검 ③ D-22) —
     *   한글 엔드유저가 필수가 된 뒤로는 그 검사가 할 일이 없었고, **영문만 적은 사람**에게 「엔드유저를 적어 주세요」로
     *   엉뚱하게 보였다(영문은 적었는데). 아래 한글 검사가 바로 말해 준다. 서버도 같은 규칙(requireEndUserKo). */
    /* ⭐엔드유저 **한글은 필수** (v2.193.0 · 사용자 결정 — 영문·홈페이지는 선택).
     *   ⚠운영 217건은 정리 SQL 로 **전부 한글 이름이 채워져 있어** 이 규칙이 옛 딜의 저장을 막지 않는다
     *     (2026-09-18 전수 확인 · 한글이 비는 건 0건). 「한글 이름이 없는 회사」 5곳은 `PSK` 처럼
     *     적혀 있던 글자를 그대로 한글 칸에 넣었다. */
    if (!form.endUserKo.trim()) {
      setFormError('엔드유저 한글 이름을 적어 주세요 — 목록·아침 알림·메일 제목이 이 이름을 씁니다. (영문·홈페이지는 선택입니다)');
      return;
    }
    /* ① 본체가 빠졌으면 **한 번 물어보고 저장한다 — 막지 않는다** (사용자 결정 2026-09-11 · v2.160.0)
     *   ⚠막지 않는 이유: 운영 딜 215건 중 P/N 이 비어 있는 것이 100건, 가격표에 없는 P/N 이 25건이라
     *     저장 경로에서 거절하면 **진행 중 130건 중 55건이 아무것도 안 고쳐도 저장이 안 된다.**
     *   ⚠물어보는 때: **새 딜**이거나 **P/N 칸을 실제로 건드렸을 때**만 — 상태만 바꾸는 사람에게는 안 묻는다. */
    const pnNow = itemsText(form);
    const pnTouched = pnNow !== pnBaselineRef.current;
    if ((!form.id || pnTouched) && !hasMainPart(pnNow, partGroupsQ.data?.mainPart)) {
      const what = pnNow.trim()
        ? '제안 품목(P/N)에 ① 본체로 보이는 품목이 없습니다.\n(호스트보드·하드디스크·기타만 적혀 있습니다)'
        : '제안 품목(P/N) 칸이 비어 있습니다.';
      if (!window.confirm(
        `${what}\n\n본체 = 가격표의 CS · GS · GSe · GSx · KS · ESDS · Expansion Enclosure · JBOD\n[🔍 가격표에서 찾기] 의 「① 본체」 에서 고를 수 있습니다.\n\n이대로 저장할까요?`,
      )) return;
    }
    // 표시용 두 칸(salesLabel · tier2CompanyName)은 서버에 보내지 않는다 — 서버는 번호(salesId · tier2CompanyId)로만 연결한다
    const { id, salesLabel, tier2CompanyName, ...input } = form;
    void salesLabel; void tier2CompanyName;
    if (id) update.mutate({ id, input: { ...input, requestId: null } });
    else create.mutate(input);
  };

  /* ── 제안사 연결 칸 (v2.143.0) ── */
  const companyNames = useMemo(() => (companies.data ?? []).filter((c) => c.isActive).map((c) => c.name), [companies.data]);
  const companyKey = (s: string): string => s.replace(/\s+/g, '').toLowerCase();
  /** 회사 글자를 바꾸면 거래처 목록에서 같은 이름을 찾아 번호를 잡는다. 회사가 바뀌면 다른 회사 담당자는 푼다 */
  const onTier2Company = (v: string): void => {
    if (!form) return;
    const key = companyKey(v);
    const found = key ? (companies.data ?? []).find((c) => companyKey(c.name) === key) ?? null : null;
    const nextId = found?.id ?? null;
    const cur = form.tier2ContactId ? contactRows.find((c) => c.id === form.tier2ContactId) : undefined;
    const keep = !!cur && (cur.partnerCompanyId === nextId || (!cur.partnerCompanyId && companyKey(cur.companyName) === key));
    setForm({ ...form, tier2CompanyName: v, tier2CompanyId: nextId, tier2ContactId: keep ? form.tier2ContactId : null });
  };
  /** 담당자를 고르면 회사가 비어 있을 때 담당자의 회사가 따라온다 */
  const onTier2Contact = (id: number | null): void => {
    if (!form) return;
    const c = id ? contactRows.find((x) => x.id === id) ?? null : null;
    const follow = c && !form.tier2CompanyId
      ? (c.partnerCompanyId ? { tier2CompanyId: c.partnerCompanyId, tier2CompanyName: c.companyName } : { tier2CompanyName: form.tier2CompanyName || c.companyName })
      : {};
    setForm({ ...form, tier2ContactId: id, ...follow });
  };
  /** 고를 수 있는 담당자 — 회사가 정해졌으면 그 회사 사람만(+지금 고른 사람), 아니면 전부 */
  const contactOptions = useMemo(() => {
    if (!form) return [];
    const key = companyKey(form.tier2CompanyName);
    return contactRows
      .filter((c) => c.isActive || c.id === form.tier2ContactId)
      .filter((c) => {
        if (c.id === form.tier2ContactId) return true;
        if (form.tier2CompanyId) return c.partnerCompanyId === form.tier2CompanyId;
        if (key) return companyKey(c.companyName) === key;
        return true;
      });
  }, [contactRows, form]);
  const addContact = useMutation({
    mutationFn: (input: PartnerContactInput) => createContact(input),
    onSuccess: (c) => {
      void qc.invalidateQueries({ queryKey: ['partnerContacts'] });
      setNewContact(null);
      setNewContactError('');
      setForm((f) => (f ? {
        ...f, tier2ContactId: c.id,
        ...(c.partnerCompanyId && !f.tier2CompanyId ? { tier2CompanyId: c.partnerCompanyId, tier2CompanyName: c.companyName } : {}),
      } : f));
    },
    onError: (e: Error) => setNewContactError(e.message),
  });
  const openNewContact = (): void => {
    if (!form) return;
    setNewContactError('');
    setNewContact(newContact ? null : {
      ...emptyContactInput(),
      partnerCompanyId: form.tier2CompanyId,
      companyName: form.tier2CompanyName || tier2Short(form.tier2),
    });
  };
  const saveNewContact = (): void => {
    if (!newContact) return;
    setNewContactError('');
    if (!newContact.companyName.trim()) { setNewContactError('회사 이름을 적어 주세요.'); return; }
    if (!newContact.name.trim() && !newContact.email.trim()) { setNewContactError('이름이나 이메일을 적어 주세요.'); return; }
    addContact.mutate(newContact);
  };

  const closedStatuses = new Set(meta.data?.closedStatuses ?? ['Won', 'Lost', 'Invalid']);
  const isClosedForm = form ? closedStatuses.has(form.status) : false;

  const exportExcel = (): void => {
    const cols: Column<DealRow>[] = [
      { key: 'registrationNo', label: '접수번호', type: 'text', accessor: (r) => r.registrationNo },
      { key: 'projectId', label: 'Project ID', type: 'text', accessor: (r) => r.projectId },
      { key: 'status', label: '상태', type: 'text', accessor: (r) => r.status },
      { key: 'tracking', label: '진행/종료', type: 'text', accessor: (r) => (r.isClosed ? 'Close' : 'Tracking') },
      { key: 'appliedDate', label: '신청일', type: 'date', accessor: (r) => r.appliedDate },
      { key: 'expireDate', label: '만료일', type: 'date', accessor: (r) => r.expireDate },
      { key: 'deadlineDate', label: '연장 마감', type: 'date', accessor: (r) => r.deadlineDate },
      { key: 'lastUpdate', label: '최근 갱신', type: 'date', accessor: (r) => r.lastUpdate },
      { key: 'closedDate', label: '종료일', type: 'date', accessor: (r) => r.closedDate },
      { key: 'expiryNoticeAt', label: '만료 안내 발송일', type: 'date', accessor: (r) => r.expiryNoticeAt },
      { key: 'infoRequestAt', label: '정보 요청 발송일', type: 'date', accessor: (r) => r.infoRequestAt },
      { key: 'tier2Company', label: '제안사 업체(거래처)', type: 'text', accessor: (r) => r.tier2CompanyName || r.tier2ContactCompany },
      { key: 'tier2Contact', label: '제안사 담당자', type: 'text', accessor: (r) => [r.tier2ContactName, r.tier2ContactEmail].filter(Boolean).join(' ') },
      { key: 'tier2', label: '제안사 (Tier 2) 메모', type: 'text', accessor: (r) => r.tier2 },
      { key: 'salesId', label: '영업진행', type: 'text', accessor: (r) => (r.salesId ? `${r.salesId}${r.salesProject ? ' ' + r.salesProject : ''}` : '') },
      { key: 'endUser', label: '엔드유저', type: 'text', accessor: (r) => r.endUser },
      { key: 'topic', label: '프로젝트명', type: 'text', accessor: (r) => dealTopic(r) },
      { key: 'topicEn', label: '프로젝트명(영문)', type: 'text', accessor: (r) => r.topicEn },
      { key: 'projectInfo', label: '프로젝트 정보', type: 'text', accessor: (r) => r.projectInfo },
      /* 업데이트 이력 (v2.194.0) — 「260918 : 내용」 줄로 이어 붙인 글은 **서버가** 만든다(updatesText).
         ⛔화면에서 다시 만들지 말 것 — 메일과 모양이 갈린다. */
      { key: 'updates', label: '업데이트 이력', type: 'text', accessor: (r) => r.updatesText },
      { key: 'projectInfoEn', label: '프로젝트 정보(영문)', type: 'text', accessor: (r) => r.projectInfoEn },
      { key: 'pn', label: 'P/N', type: 'text', accessor: (r) => r.pn },
      { key: 'remark', label: 'Remark', type: 'text', accessor: (r) => r.remark },
      { key: 'application', label: '애플리케이션', type: 'text', accessor: (r) => r.application },
      { key: 'ownerName', label: '담당자', type: 'text', accessor: (r) => r.ownerName },
      { key: 'amountUsd', label: '금액(USD)', type: 'number', accessor: (r) => r.amountUsd },
      { key: 'note', label: '비고', type: 'text', accessor: (r) => r.note },
    ];
    const scopeLabel = scope === 'tracking' ? (expiringOnly ? '만료임박' : '진행중') : scope === 'closed' ? `종료${year ? '_' + year : ''}` : '전체';
    exportRowsToExcel({
      filename: `딜등록_인포트렌드_${scopeLabel}_${dateStamp()}.xlsx`,
      sheetName: scopeLabel,
      columns: cols,
      rows,
      colWidths: { tier2: 30, endUser: 30, projectInfo: 60, updates: 50, pn: 24, remark: 20 },
    });
  };

  const counts = list.data?.counts;
  const employees = meta.data?.employees ?? [];
  const requestRows = requests.data?.rows ?? [];
  const requestCount = requests.data?.counts.unlinked ?? 0;

  return (
    <div className="p-6">
      <div className="flex flex-wrap items-end gap-3 mb-3">
        {/* v2.219.0 — [📥 만료예정 상태표] 가 늘며 1536 에서 단추 묶음이 제목 아래 줄로 내려갔다(실측 한 줄 1187 → 1338px · 폭 1248).
            제목 칸이 줄어들 수 있게(기준 폭 20rem) 하고 설명 글은 한 줄로 자른다(마우스를 올리면 전체) — 높이는 그대로 */}
        <div className="flex-1 basis-80 min-w-0">
          <h1 className="ui-page-title">딜등록 요청</h1>
          <p
            className="ui-page-sub truncate"
            title="제안사(Tier 2)에게 정보를 요청하고 → 벤더 본사에 딜등록한 목록 — 접수번호 · Project ID · 만료 · 연장 마감"
          >
            제안사(Tier 2)에게 정보를 요청하고 → 벤더 본사에 딜등록한 목록 — 접수번호 · Project ID · 만료 · 연장 마감
          </p>
        </div>
        <div className="ml-auto flex items-center gap-2">
          <button
            type="button"
            onClick={exportExcel}
            disabled={rows.length === 0 || view !== 'deals'}
            className="btn btn-secondary"
          >
            📥 엑셀
          </button>
          {/* v2.219.0: 25일에 메시지방에 올라가는 상태표(엑셀)를 누른 순간의 자료로 — 옛 [🔔 월간 안내 ▼] 안 「25일 상태표 받기」를 옮김 */}
          <DealStatusXlsxButton onNotice={setNotice} />
          {/* v2.147.0: 제안사에 보내는 만료 안내 메일의 문구를 화면에서 고친다 (고치기는 경영지원·관리자 — 서버가 막는다) */}
          <button
            type="button"
            onClick={() => setTemplateOpen(true)}
            title="제안사에 보내는 만료 안내 메일의 문구를 보고 고칩니다"
            className="btn btn-secondary"
          >
            ✏ 만료 안내 문구
          </button>
          {/* v2.215.0: 매월 20일 안내 · 24일 검토 표 · 25일 상태표 — 미리보기(누구나 · 나만) · 시험발송(관리자 · 방에 올라감).
              옛 「🔔 알림 시험발송」(월요일 아침 알림) 단추를 대신한다 */}
          <DealMonthlyNoticeMenu isAdmin={user?.role === 'admin'} onNotice={setNotice} />
          <button
            type="button"
            onClick={openRequestBlank}
            disabled={!contacts.data}
            title="제안사 담당자에게 「딜등록정보요청」 양식을 채워 메일로 보낸다"
            className="btn btn-outline"
          >
            ✉ 정보 요청
          </button>
          <button
            type="button"
            onClick={openNew}
            disabled={!meta.data}
            className="btn btn-primary"
          >
            ＋ 새 딜등록
          </button>
        </div>
      </div>

      {/* 벤더 탭 — 지금은 인포트렌드 하나. 시게이트 등은 여기에 탭이 늘어난다 */}
      <PageTabs
        tabs={(meta.data?.vendors ?? [{ id: 'infortrend', label: '인포트렌드' }]).map((v) => ({
          key: v.id,
          label: `${v.label} 딜등록`,
        }))}
        value={vendor}
        onChange={() => undefined}
        ariaLabel="딜등록 벤더"
        className="mb-3"
        right={<span className="ui-help">다른 벤더는 준비 중</span>}
      />

      {notice ? (
        <div className="mb-3 px-3 py-2 rounded border border-emerald-200 bg-emerald-50 text-sm text-emerald-800 flex items-center">
          <span>{notice}</span>
          <button type="button" onClick={() => setNotice('')} className="ml-auto text-emerald-700 hover:text-emerald-900 text-base leading-none" aria-label="닫기">×</button>
        </div>
      ) : null}

      <div className="bg-white rounded border border-slate-200">
        {/* 진행 중 / 종료 / 정보 요청 + 필터 */}
        <div className="flex flex-wrap items-center gap-2 px-3 py-2 border-b border-slate-100">
          <SegmentedControl
            ariaLabel="딜등록 목록 거르기"
            options={[
              { key: 'tracking', label: '진행 중', count: counts?.tracking },
              { key: 'closed', label: '종료', count: counts?.closed },
              {
                key: 'requests',
                label: '✉ 정보 요청',
                count: requests.data ? requestCount : undefined,
                tone: 'warn',
                title: '제안사에 보낸 딜등록 정보 요청 — 아직 딜등록으로 만들지 않은 것',
              },
            ]}
            value={view === 'requests' ? 'requests' : scope === 'closed' ? 'closed' : 'tracking'}
            onChange={(k) => (k === 'requests' ? setView('requests') : switchScope(k))}
          />

          {view === 'deals' && scope === 'tracking' && (
            <button
              type="button"
              onClick={toggleExpiring}
              title={`연장 마감이 ${EXPIRING_DAYS}일 안이거나 지난 건만 (마감 임박순) — 24일 검토 표·25일 엑셀에 나갈 딜 그대로(종료 탭으로 넘기기 전 실주·무효 포함)`}
              className={`btn btn-sm ${expiringOnly ? 'btn-warning-solid' : 'btn-warning'}`}
            >
              ⏰ 만료 임박 <b>{expiringCount}</b>
            </button>
          )}

          {/* v2.215.0 — 종료 상태로 바꾼 딜은 진행 중 탭에 남는다. 여기서 골라 종료 탭으로 넘긴다 */}
          {view === 'deals' && scope === 'tracking' && (
            <button
              type="button"
              onClick={() => setArchiveOpen(true)}
              data-deal-archive-open
              title="진행 중 탭에 남은 종료 상태(수주·실주·무효·거절) 딜을 골라 종료 탭으로 넘깁니다"
              className={`btn btn-sm ${archiveCount > 0 ? 'btn-secondary' : 'btn-secondary'}`}
            >
              📦 종료 탭으로 넘기기 <b>{archiveCount}</b>
            </button>
          )}

          {view === 'deals' && scope === 'closed' && (
            <div className="flex flex-wrap items-center gap-1 text-xs">
              <button
                type="button"
                onClick={() => setYear(null)}
                className={`btn btn-sm ${year === null ? 'btn-dark' : 'btn-secondary'}`}
              >
                전체
              </button>
              {lastByYear.map((y) => (
                <button
                  key={String(y.year)}
                  type="button"
                  onClick={() => setYear(y.year)}
                  className={`btn btn-sm ${year === y.year ? 'btn-dark' : 'btn-secondary'}`}
                >
                  {y.year ?? '연도 없음'} <span className="opacity-70">{y.count}</span>
                </button>
              ))}
            </div>
          )}

          {view === 'requests' ? (
            <label className="flex items-center gap-1.5 text-xs text-slate-600 ml-2">
              <input type="checkbox" checked={showLinked} onChange={(e) => setShowLinked(e.target.checked)} />
              딜등록으로 만든 요청도 보기 {requests.data ? <span className="text-slate-400">(전체 {requests.data.counts.total})</span> : null}
            </label>
          ) : (
            <>
              <input
                value={q}
                onChange={(e) => setQ(e.target.value)}
                placeholder="접수번호 · Project ID · 제안사 · 엔드유저 · 프로젝트 내용 검색"
                // v2.215.0 — 기본 폭 224px 로 줄 바꿈을 정하고, 남는 자리가 있으면 원래 폭(288px)까지 늘어난다.
                //   [📦 종료 탭으로 넘기기] 가 생기며 1536 에서 필터 줄이 두 줄로 접혔다(실측 52→86px).
                className="ui-input ml-auto w-56 grow max-w-[18rem]"
              />
              <select
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value as DealStatus | '')}
                className="ui-input"
              >
                <option value="">상태 전체</option>
                {(meta.data?.statuses ?? [])
                  .filter((s) => scope === 'all' || (scope === 'closed' ? s.closed : !s.closed))
                  .map((s) => (
                    <option key={s.id} value={s.id}>{s.id} · {s.label}</option>
                  ))}
              </select>
              {/* v2.147.0: 담당자 고르기 칸은 없앴다 (사용자 「필요하면 표에서 필터링 하면 되니까」) —
                  표 머리글 「담당자」 옆 🔍 로 고른다. 서버의 empId 파라미터는 그대로 두었다(대시보드가 쓴다). */}
              {/* 정렬은 표 머리글을 누른다(오름→내림→해제 · 다른 머리글을 누르면 다단계). 우측 묶음 — [필터·정렬 초기화 ▼] [📐 내 표 설정 | ↺ 초기화] */}
              <ResetMenu
                defaultLabel="진행 중 탭 · 신청일 최신순 · 검색·필터 없음"
                onResetDefault={resetToDefault}
                onResetAll={clearListState}
              />
              <ExcelModeGroup
                enabled={excelMode}
                hasPrefs={hasPrefs}
                userName={user?.name ?? '사용자'}
                onChange={(on) => patchPrefs.mutate({ dealTabExcelMode: on })}
                onReset={handleExcelModeReset}
              />
            </>
          )}
        </div>

        {/* ⚙ 표시 컬럼 — 📐 내 표 설정 ON 일 때만. 모바일 hidden. (영업진행과 같은 모양) */}
        {view === 'deals' && excelMode ? (
          <div className="hidden md:block px-3 py-2 border-b border-slate-100 text-xs">
            <div className="flex items-center justify-between">
              <button type="button" onClick={() => setColMenuOpen((v) => !v)} className="text-blue-600 hover:underline">
                ⚙ 표시 컬럼 ({visibleColumns.length}/{DEAL_ALL_KEYS.length}{patchPrefs.isPending ? ' · 저장 중...' : ''}){colMenuOpen ? ' ▲' : ' ▼'}
              </button>
              <span className="text-xs text-slate-500">💡 머리글을 끌면 순서 변경 · 우측 끝을 끌면 너비 조정 · 머리글 클릭은 정렬 (자동 저장)</span>
            </div>
            {colMenuOpen ? (
              <div className="mt-2 grid grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-1">
                {columns.map((d) => {
                  const on = activeColKeys.has(d.key);
                  return (
                    <label key={d.key} className={`flex items-center gap-1.5 px-2 py-1 rounded cursor-pointer text-xs ${on ? 'bg-blue-50 text-blue-800' : 'text-slate-500 hover:bg-slate-50'}`}>
                      <input type="checkbox" checked={on} onChange={() => toggleColumn(d.key)} disabled={patchPrefs.isPending} />
                      <span>{d.toggleLabel ?? d.label}</span>
                    </label>
                  );
                })}
              </div>
            ) : null}
          </div>
        ) : null}

        {/* ── 보낸 정보 요청 ── */}
        {view === 'requests' && (
          <>
            {requests.isLoading && <div className="py-10 text-center text-slate-400 text-sm"><LoadingLines /></div>}
            {requests.isError && (
              <div className="py-8 text-center text-sm text-rose-600">요청 목록을 불러오지 못했습니다 — {(requests.error as Error).message}</div>
            )}
            {requests.data && (
              <div className="overflow-x-auto">
                <table className="data-table dense w-full text-xs">
                  <thead>
                    <tr>
                      <th className="text-left w-[110px]">보낸 때</th>
                      <th className="text-left w-[18%] min-w-[170px]">제안사<br /><span className="font-normal text-slate-400">받는사람</span></th>
                      <th className="text-left w-[16%] min-w-[140px]">엔드유저</th>
                      <th className="text-left w-[22%] min-w-[180px]">프로젝트명<br /><span className="font-normal text-slate-400">진행 현황</span></th>
                      <th className="text-left w-[64px]">보낸 사람</th>
                      <th className="text-left w-[130px]">딜등록</th>
                      <th className="text-center w-[250px]"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {requestRows.length === 0 && (
                      <tr>
                        <td colSpan={7} className="py-8 text-center text-slate-400">
                          {showLinked ? '보낸 정보 요청이 없습니다.' : '아직 딜등록으로 만들지 않은 정보 요청이 없습니다. 위의 [✉ 정보 요청] 으로 보냅니다.'}
                        </td>
                      </tr>
                    )}
                    {requestRows.map((r) => (
                      <tr key={r.id} className={r.dealId ? 'text-slate-500' : ''}>
                        <td className="text-left align-top whitespace-nowrap tabular-nums">{r.sentAt}</td>
                        <td className="text-left align-top max-w-0">
                          <div className="font-semibold text-slate-800 truncate" title={r.company}>{r.company || '-'}{r.contactName ? ` · ${r.contactName}` : ''}</div>
                          <div className="text-slate-500 truncate" title={r.toEmails.join(', ')}>{r.toEmails.join(', ')}</div>
                        </td>
                        <td className="text-left align-top max-w-0"><div className="truncate" title={r.endUser}>{r.endUser || '-'}</div></td>
                        <td className="text-left align-top max-w-0">
                          <div className="truncate text-slate-800" title={r.projectName}>{r.projectName || '-'}</div>
                          {r.projectStatus ? <div className="truncate text-slate-500" title={r.projectStatus}>{r.projectStatus}</div> : null}
                        </td>
                        <td className="text-left align-top whitespace-nowrap">{r.sentByName || r.sentBy || '-'}</td>
                        <td className="text-left align-top">
                          {r.dealId ? (
                            <button
                              type="button"
                              onClick={() => { setView('deals'); setScope('tracking'); setDetailId(r.dealId); }}
                              className="text-blue-700 hover:underline truncate max-w-[120px] block text-left tabular-nums"
                              title="연결된 딜등록 열기"
                            >
                              {r.dealLabel || `#${r.dealId}`}
                            </button>
                          ) : <span className="text-amber-700">회신 대기</span>}
                        </td>
                        <td className="text-center align-top whitespace-nowrap">
                          {!r.dealId ? (
                            <button
                              type="button"
                              onClick={() => openNewFromRequest(r)}
                              disabled={!meta.data}
                              className="btn btn-primary btn-sm mr-1"
                              title="회신받은 내용으로 새 딜등록을 만든다 (이 요청과 연결됨)"
                            >
                              ＋ 딜등록으로 만들기
                            </button>
                          ) : null}
                          <button type="button" onClick={() => openRequestAgain(r)} className="btn btn-outline btn-sm mr-1">✉ 다시</button>
                          <button type="button" onClick={() => askDeleteRequest(r)} className="btn btn-danger btn-sm">삭제</button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
            {requests.data && (
              <div className="px-3 py-2 text-xs text-slate-500 border-t border-slate-100">
                {requestRows.length}건 · 회신이 오면 [＋ 딜등록으로 만들기] — 새 딜등록 창이 제안사·엔드유저·프로젝트로 채워져 뜨고, 넣으면 이 요청과 연결됩니다
              </div>
            )}
          </>
        )}

        {view === 'deals' && list.isLoading && <div className="py-10 text-center text-slate-400 text-sm"><LoadingLines /></div>}
        {view === 'deals' && list.isError && (
          <div className="py-8 text-center text-sm text-rose-600">
            목록을 불러오지 못했습니다 — {(list.error as Error).message}
          </div>
        )}

        {view === 'deals' && list.data && (
          <div className="overflow-x-auto">
            {/* dense(좌우 여백 5px): 기본 칸 9개가 1280 에서 기본 여백으로는 28px 넘쳤다 (2026-09-08 실측).
                머리글은 공용 ColumnHeader — 클릭 정렬 · 돋보기 필터 · 📐 켜면 끌어서 순서·너비 (v2.144.0) */}
            <table className="data-table dense w-full text-xs">
              <thead>
                <tr>
                  {visibleColumns.map((col, idx) => (
                    <ColumnHeader
                      key={col.key}
                      column={col}
                      baseRows={baseRows}
                      // 연쇄 필터 — applyColState 에 넘기는 것과 같은 전체 칸 집합(숨긴 칸의 필터도 표에는 걸려 있다)
                      columns={DEAL_COLUMNS}
                      colState={colState}
                      excelMode={excelMode}
                      onReorder={excelMode ? handleReorder : undefined}
                      onMoveLeft={excelMode && idx > 0 ? () => handleMoveLeft(col.key) : undefined}
                      onMoveRight={excelMode && idx < visibleColumns.length - 1 ? () => handleMoveRight(col.key) : undefined}
                      onResize={excelMode ? handleResize : undefined}
                      widthPx={columnWidths?.[col.key] ?? col.defaultWidthPx}
                    />
                  ))}
                </tr>
              </thead>
              <tbody>
                {rows.length === 0 && (
                  <tr><td colSpan={Math.max(visibleColumns.length, 1)} className="py-8 text-center text-slate-400">해당하는 딜등록이 없습니다.</td></tr>
                )}
                {rows.map((r) => (
                  <tr
                    key={r.id}
                    onClick={() => setDetailId(r.id)}
                    className={`cursor-pointer hover:bg-slate-50 ${detailId === r.id ? 'bg-blue-50' : ''}`}
                  >
                    {visibleColumns.map((col) => {
                      const alignCls = col.align === 'right' ? 'text-right' : col.align === 'center' ? 'text-center' : 'text-left';
                      return (
                        <td key={col.key} className={`align-top ${alignCls} ${col.cellClass ?? ''} ${col.mobileHidden ? 'hidden md:table-cell' : ''}`}>
                          {col.render ? col.render(r) : (col.accessor(r) ?? '')}
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        {view === 'deals' && list.data && (
          <div className="px-3 py-2 text-xs text-slate-500 border-t border-slate-100">
            {rows.length}건{rows.length !== baseRows.length ? ` (필터 전 ${baseRows.length}건)` : ''}
            {amountSum.n > 0 ? (
              <> · <span className="text-slate-600">금액 합계 <strong className="tabular-nums text-slate-800">{fmtUsd(amountSum.sum)}</strong> (금액이 적힌 {amountSum.n}건)</span></>
            ) : null} · 줄을 누르면 상세 · 머리글을 누르면 정렬(다시 누르면 반대, 한 번 더 누르면 해제) ·
            머리글 옆 🔍 로 값 골라 보기 · 연장 마감이 {EXPIRING_DAYS}일 안이면 주황, 지났으면 빨강 · ✉ 는 제안사에 만료 안내 메일
          </div>
        )}
      </div>

      {/* v2.143.0: 제안사 담당자 명단은 거래처 담당자 주소록으로 통합됐다 — 여기서는 문만 낸다 */}
      <div className="mt-3 text-xs text-slate-500 flex flex-wrap items-center gap-2">
        <span>👤 제안사 담당자 명단은 <b>거래처 › 거래처 담당자</b>(주소록)에서 관리합니다 — 딜의 [수정] 에서 고르거나 [＋ 새 담당자] 로 넣습니다.</span>
        <Link to="/partners?tab=contacts" className="text-blue-700 hover:underline">주소록 열기 →</Link>
      </div>

      {/* ── 상세 창 ── */}
      {detail && !form ? (
        <div className="fixed inset-0 bg-black/40 z-[70] flex items-start justify-center overflow-y-auto p-4">
          <div className="bg-white rounded shadow-lg w-full max-w-3xl mt-8">
            <div className="px-4 py-3 border-b border-slate-200 flex items-center gap-2">
              <span className={`inline-block px-1.5 py-0.5 rounded text-xs font-semibold ${STATUS_BADGE[detail.status]}`}>
                {detail.status} · {detail.statusLabel}
              </span>
              <span className="text-sm font-semibold text-slate-800 tabular-nums">{detail.registrationNo || '(접수번호 없음)'}</span>
              <span className="text-sm text-slate-500 tabular-nums">{detail.projectId}</span>
              <button
                type="button"
                onClick={() => setDetailId(null)}
                className="ui-close ml-auto"
                aria-label="닫기"
              >
                ×
              </button>
            </div>
            <div className="p-4 space-y-3 text-sm">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-2 text-xs">
                <Field label="신청일">{detail.appliedDate ?? '-'}</Field>
                <Field label="만료일">{detail.expireDate ?? '-'}</Field>
                <Field label="연장 마감">
                  {detail.deadlineDate ?? '-'}
                  {(() => { const dd = ddayText(detail); return dd ? <span className={`ml-1 px-1.5 rounded font-semibold ${dd.cls}`}>{dd.text}</span> : null; })()}
                </Field>
                <Field label="최근 갱신">{detail.lastUpdate ?? '-'}</Field>
                <Field label="담당자">{detail.ownerName || '-'}</Field>
                <Field label="애플리케이션">{detail.application || '-'}</Field>
                <Field label="금액 (USD)">
                  {detail.amountUsd === null
                    ? <span className="text-slate-400">-</span>
                    : <span className="tabular-nums font-semibold text-slate-800">{fmtUsd(detail.amountUsd)}</span>}
                </Field>
                <Field label="종료일">{detail.closedDate ?? (detail.isClosed ? '-' : '진행 중')}</Field>
                <Field label="만료 안내 메일">{detail.expiryNoticeAt ? `${detail.expiryNoticeAt} 보냄` : '안 보냄'}</Field>
                <Field label="정보 요청 메일">{detail.infoRequestAt ? `${detail.infoRequestAt} 보냄` : '-'}</Field>
              </div>
              {/* 연결 (v2.143.0) — 거래처 · 주소록 담당자 · 영업진행 건 */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-2 text-xs">
                <Field label="제안사 업체 (거래처)">
                  {detail.tier2CompanyName ? (
                    <><span className="text-emerald-700">✓</span> {detail.tier2CompanyName}</>
                  ) : detail.tier2ContactCompany ? (
                    <>{detail.tier2ContactCompany} <span className="text-amber-700">(거래처 미연결)</span></>
                  ) : (
                    <span className="text-slate-400">연결 없음 — [수정] 에서 거래처를 고르세요</span>
                  )}
                </Field>
                <Field label="제안사 담당자 (주소록)">
                  {detail.tier2ContactName ? (
                    <>{detail.tier2ContactName}{detail.tier2ContactEmail ? <span className="text-slate-500"> · {detail.tier2ContactEmail}</span> : null}</>
                  ) : (
                    <span className="text-slate-400">연결 없음</span>
                  )}
                </Field>
                <Field label="영업진행 건">
                  {detail.salesId ? (
                    <Link to={`/sales?open=${encodeURIComponent(detail.salesId)}`} className="text-blue-700 hover:underline" title="영업진행에서 이 건을 연다">
                      {detail.salesId}{detail.salesProject ? ` · ${detail.salesProject}` : ''} ↗
                    </Link>
                  ) : (
                    <span className="text-slate-400">연결 없음</span>
                  )}
                </Field>
              </div>
              <Block label="제안사 (Tier 2) 메모 — 회사 · 담당자 · 연락처 원문" text={detail.tier2} />
              <Block label="엔드유저" text={detail.endUser} />
              {/* 프로젝트명(v2.189.0) — 옛 자료는 칸이 비어 있고 프로젝트 정보 글 안에 섞여 있다.
                  dealTopic 이 두 길을 다 본다. 영문은 적어 둔 것이 있을 때만 보여 준다. */}
              <Block label="프로젝트명" text={dealTopic(detail)} />
              {detail.topicEn ? <Block label="프로젝트명 (영문)" text={detail.topicEn} /> : null}
              <Block label="프로젝트 정보" text={detail.projectInfo} tall />
              {/* 📝 업데이트 이력 (v2.194.0) — 「나중에 누적해서 볼수는 있어야 되고」.
                  ⭐옛 딜의 경과 줄은 위 「프로젝트 정보」 칸에 그대로 있다(사용자 결정 — 옮기지 않았다). */}
              <UpdateLog
                deal={detail}
                busy={addUpdate.isPending || editUpdate.isPending || removeUpdate.isPending}
                onAdd={(body) => addUpdate.mutate({ id: detail.id, body })}
                onEdit={(updateId, body, date) => editUpdate.mutate({ id: detail.id, updateId, body, date })}
                onRemove={(updateId) => {
                  if (!window.confirm('이 업데이트를 지울까요?\n(지운 것은 변경 이력에 남습니다)')) return;
                  removeUpdate.mutate({ id: detail.id, updateId });
                }}
              />
              {detail.projectInfoEn ? <Block label="프로젝트 정보 (영문)" text={detail.projectInfoEn} /> : null}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                {/* 상세 창도 **품목 칸·수량 칸으로 나눠서** 보여 준다 (v2.178.1 · 사용자 지적:
                    「입력,수정모드에선 분리되어 보이는데 이미 작성된 딜 클릭하면 분리가 안되어 보여」).
                    ⚠품목 줄이 아직 없는 딜(옛 자료·빈 칸)은 종전처럼 글자 그대로 보인다. */}
                <ItemsBlock items={detail.items} fallbackText={detail.pn} />
                <Block label="Remark" text={detail.remark} />
              </div>
              <Block label="비고" text={detail.note} />
              {/* 🕘 최근 변경 · 변경 이력 (v2.306.0) — 상태를 안 바꾸고 내용만 고쳐도 무엇이 바뀌었나 */}
              <DealChangeBox dealId={detail.id} lastChange={detail.lastChange ?? null} />
              <div className="text-xs text-slate-500">
                {detail.sourceRef
                  ? `엑셀에서 옮겨 온 줄 (${detail.sourceRef.replace(/^xlsx:/, '').replace(':', ' 시트 ')}) · `
                  : `포털에서 넣음 (${detail.createdBy}) · `}
                만든 때 {detail.createdAt} · 고친 때 {detail.updatedAt} ({detail.updatedBy || '-'})
              </div>
            </div>
            <div className="px-4 py-3 border-t border-slate-200 flex items-center gap-2">
              <button
                type="button"
                onClick={() => askDelete(detail)}
                disabled={remove.isPending}
                className="btn btn-danger"
              >
                삭제
              </button>
              {/* 승인대기 건에는 만료일이 없다 — 표의 ✉ 칸과 **같은 판정**으로 여기서도 안 낸다 (v2.189.0) */}
              {!detail.isClosed && detail.status !== 'Pending' ? (
                <button
                  type="button"
                  onClick={() => void sendExpiryMail(detail)}
                  disabled={mailBusyId === detail.id}
                  className="btn btn-warning"
                >
                  ✉ 만료 안내 메일
                </button>
              ) : null}
              {/* ✉ 딜등록 안내 (v2.190.0) — 접수번호·Project ID 가 다 있어야 보낼 수 있다.
                  ⭐**못 보낼 때도 단추는 남겨 둔다** — 눌러 보면 서버가 「왜 못 보내는지」를 문장으로 알려 준다.
                  회색으로만 두고 이유를 안 적으면, 사용자는 화면을 새로고침하며 헤맨다. */}
              {!detail.isClosed && detail.registrationNo ? (
                <>
                  <button
                    type="button"
                    onClick={() => void sendNoticeMail(detail, 'tier2')}
                    disabled={mailBusyId === detail.id}
                    title={detail.projectId
                      ? '제안사(Tier 2) 담당자에게 딜등록 안내 메일'
                      : 'Project ID 를 받아 적으면 보낼 수 있습니다'}
                    className={`btn ${detail.projectId ? 'btn-outline' : 'btn-secondary'}`}
                  >
                    ✉ 딜등록 안내 (제안사)
                  </button>
                  <button
                    type="button"
                    onClick={() => void sendNoticeMail(detail, 'infortrend')}
                    disabled={mailBusyId === detail.id}
                    title={detail.projectId
                      ? '인포트렌드 담당자에게 딜등록 안내 메일 (한글 + 영문)'
                      : 'Project ID 를 받아 적으면 보낼 수 있습니다'}
                    className={`btn ${detail.projectId ? 'btn-outline' : 'btn-secondary'}`}
                  >
                    ✉ 딜등록 안내 (인포트렌드)
                  </button>
                </>
              ) : null}
              {/* ⛔[✉ 정보 요청] 단추는 v2.193.2 에서 **뺐다** (사용자: 「이미 등록된 딜에는 정보요청 버튼이 필요가 없어」).
                  정보 요청은 **딜을 만들기 전에** 제안사에서 내용을 받아 오는 절차라, 이미 등록된 딜에서는 쓸 일이 없다.
                  새 요청은 목록 위의 [✉ 정보 요청] 으로 보낸다(그 자리는 그대로 둔다). */}
              <div className="ml-auto flex gap-2">
                <button
                  type="button"
                  onClick={() => setDetailId(null)}
                  className="btn btn-secondary"
                >
                  닫기
                </button>
                <button
                  type="button"
                  onClick={() => openEdit(detail)}
                  disabled={!meta.data}
                  className="btn btn-primary"
                >
                  수정
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : null}

      {/* ── 등록·수정 창 ──
          ⚠배경을 눌러도 닫히지 않는다 — 프로젝트 정보를 길게 적다가 빈 곳을 누르면 통째로 사라지기 때문.
          닫기는 [취소]·× 로만 (검사 그물 `check:modal`). */}
      {form ? (
        <div className="fixed inset-0 bg-black/40 z-[80] flex items-start justify-center overflow-y-auto p-4">
          <div className="bg-white rounded shadow-lg w-full max-w-3xl mt-6">
            <div className="px-4 py-3 border-b border-slate-200 text-sm font-semibold flex items-center">
              {form.id ? '딜등록 수정' : '새 딜등록 (인포트렌드)'}
              {form.requestId ? <span className="ml-2 text-xs font-normal text-amber-700">— 정보 요청의 회신으로 만드는 중 (넣으면 요청과 연결됩니다)</span> : null}
              <button
                type="button"
                onClick={() => setForm(null)}
                disabled={saving}
                className="ui-close ml-auto"
                aria-label="닫기"
              >
                ×
              </button>
            </div>
            <div className="p-4 space-y-3 text-sm">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
                <label className="block">
                  <span className="block text-xs text-slate-500 mb-1">상태 *</span>
                  <select
                    value={form.status}
                    onChange={(e) => setForm({ ...form, status: e.target.value as DealStatus })}
                    className="ui-input w-full"
                  >
                    {(meta.data?.statuses ?? []).map((s) => (
                      <option key={s.id} value={s.id}>{s.id} · {s.label}</option>
                    ))}
                  </select>
                </label>
                <label className="block">
                  <span className="block text-xs text-slate-500 mb-1">접수번호 <span className="text-slate-400">(본사 등록 후)</span></span>
                  <input
                    value={form.registrationNo}
                    maxLength={40}
                    onChange={(e) => setForm({ ...form, registrationNo: e.target.value })}
                    placeholder="D20260907004"
                    className="ui-input w-full tabular-nums"
                  />
                </label>
                <label className="block">
                  <span className="block text-xs text-slate-500 mb-1">Project ID <span className="text-slate-400">(본사 등록 후)</span></span>
                  <input
                    value={form.projectId}
                    maxLength={80}
                    onChange={(e) => setForm({ ...form, projectId: e.target.value })}
                    placeholder="IFTKR-212136"
                    className="ui-input w-full tabular-nums"
                  />
                </label>
                <label className="block">
                  <span className="block text-xs text-slate-500 mb-1">담당자</span>
                  <select
                    value={form.empId}
                    onChange={(e) => setForm({ ...form, empId: e.target.value })}
                    className="ui-input w-full"
                  >
                    <option value="">{form.ownerName ? `(직원 표 밖) ${form.ownerName}` : '(없음)'}</option>
                    {employees.map((e) => (
                      <option key={e.empId} value={e.empId}>{e.name}</option>
                    ))}
                    {form.empId && !employees.some((e) => e.empId === form.empId) ? (
                      <option value={form.empId}>{form.ownerName || form.empId}</option>
                    ) : null}
                  </select>
                </label>
              </div>

              {/* ⭐**무슨 일이 일어나는지 미리 적어 둔다** (v2.189.0).
                  상태가 저절로 바뀌고 메시지방에 글이 올라가는 것은 놀랄 일이라, 누르기 전에 알려 준다.
                  ⛔새 딜과 이미 있는 딜은 **일어나는 일이 다르다** — 문구도 갈라 적는다
                  (새로 넣을 때만 요약이 올라가고, 번호 부여 안내는 고칠 때만 올라간다). */}
              {form.status === 'Pending' ? (
                <div className="text-xs text-amber-900 bg-amber-50 border border-amber-200 rounded px-3 py-2">
                  {form.id === null ? (
                    <>
                      📝 <b>승인대기</b>로 저장됩니다 — <b>딜등록 요청</b> 메시지방에 이 내용이 요약되어 올라갑니다.
                      (빈 칸은 빠집니다.) 신청일·만료일은 <b>승인된 뒤</b>에 채워집니다.
                    </>
                  ) : (
                    <>
                      📝 <b>승인대기</b>입니다 — 인포트렌드에서 번호를 받아 <b>접수번호</b>에 적고 저장하면
                      상태가 <b>진행</b>으로 바뀌고, 신청일(오늘)·만료일(+{rule.expireMonths}개월)이 채워지며
                      메시지방에 <b>번호 부여</b> 안내가 올라갑니다. 거절됐으면 상태를 <b>Rejected · 거절</b>로 바꿔 주세요.
                    </>
                  )}
                </div>
              ) : null}

              <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
                <div>
                  <span className="block text-xs text-slate-500 mb-1">신청일</span>
                  <DateInput value={form.appliedDate} onChange={onApplied} />
                </div>
                <div>
                  <span className="block text-xs text-slate-500 mb-1 flex items-center">
                    만료일 <span className="text-slate-400 ml-1">(신청 +{rule.expireMonths}개월)</span>
                    <button
                      type="button"
                      onClick={extendSixMonths}
                      title={`연장 처리 — 만료일을 ${rule.expireMonths}개월 뒤로 (마감도 따라감 · 진행 중이면 상태를 Extend 로)`}
                      className="btn btn-outline btn-sm ml-auto"
                    >
                      +{rule.expireMonths}개월
                    </button>
                  </span>
                  <DateInput value={form.expireDate} onChange={onExpire} />
                </div>
                <div>
                  <span className="block text-xs text-slate-500 mb-1">연장 마감 <span className="text-slate-400">(만료 +{rule.deadlineDays}일)</span></span>
                  <DateInput value={form.deadlineDate} onChange={(v) => setForm({ ...form, deadlineDate: v })} />
                </div>
                {isClosedForm ? (
                  <div>
                    <span className="block text-xs text-slate-500 mb-1">종료일 <span className="text-slate-400">(비우면 오늘)</span></span>
                    <DateInput value={form.closedDate} onChange={(v) => setForm({ ...form, closedDate: v })} />
                  </div>
                ) : null}
              </div>

              {/* ── 🟡 주요 항목 (v2.193.0 · 차례와 바탕은 v2.193.1) ──
                     사용자 요청 2026-09-18: 「우선 필수 입력해야 하는 내용을 입력모달 안에 따로 묶어두고싶어 …
                     영업진행건은 아래로 내리고 프로젝트명과 앤드유저, 제안품목 을 주요항목으로 위로 넣어줘.
                     입력 칸 배경을 흐린 노란색으로 해서 구별되게 해줘」
                     ⭐노란 바탕은 `KEY_INPUT` 한 곳에 적어 둔다 — 칸마다 따로 적으면 반드시 갈린다.
                     ⭐⭐v2.193.1 — 사용자 지적 「노란색 안에 또 노란색 박스가 있어서 시인성이 안 좋다」:
                        **상자에는 바탕색을 두지 않는다**. 노란 바탕은 입력 칸에만 두고 상자는 테두리로만 묶는다.
                        차례도 사용자가 정한 것: **엔드유저 → 제안사 → 프로젝트명 → 제안 품목**. */}
              <div className="rounded border border-amber-300 p-2.5 space-y-2">
                <div className="text-xs font-semibold text-amber-800">
                  🟡 주요 항목 <span className="font-normal text-amber-700/80">— 딜을 찾고 안내 메일을 만드는 데 쓰는 값입니다</span>
                </div>

                {/* ── 엔드유저 세 칸 (v2.193.0) — 종전에는 「1) 영문 2) 한글 3) 홈페이지」를 한 칸에 적었다.
                       ⭐한글만 필수(사용자 결정 「홈페이지는 필수에서 빼줘」).
                       ⚠서버는 이 세 칸으로 `end_user` 표준 글자를 **다시 만든다** — 화면은 세 칸만 보낸다. ── */}
                <div>
                  <span className="block text-xs text-slate-600 mb-1">
                    엔드유저 <span className="text-slate-400">(인포트렌드 안내 메일의 End User)</span>
                  </span>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
                    <label className="block">
                      <span className="block text-xs text-slate-500 mb-0.5">한글 <span className="text-rose-600 font-semibold">*</span></span>
                      <input
                        value={form.endUserKo}
                        maxLength={500}
                        onChange={(e) => setForm({ ...form, endUserKo: e.target.value })}
                        placeholder="서울특별시 소방재난본부"
                        className={KEY_INPUT}
                      />
                    </label>
                    <label className="block">
                      <span className="block text-xs text-slate-500 mb-0.5">영문 <span className="text-slate-400">(선택)</span></span>
                      <input
                        value={form.endUserEn}
                        maxLength={500}
                        onChange={(e) => setForm({ ...form, endUserEn: e.target.value })}
                        placeholder="Seoul Metropolitan Fire & Disaster HQ"
                        className={KEY_INPUT_OPTIONAL}
                      />
                    </label>
                    <label className="block">
                      <span className="block text-xs text-slate-500 mb-0.5">홈페이지 <span className="text-slate-400">(선택)</span></span>
                      <input
                        value={form.endUserUrl}
                        maxLength={500}
                        onChange={(e) => setForm({ ...form, endUserUrl: e.target.value })}
                        placeholder="https://fire.seoul.go.kr"
                        className={KEY_INPUT_OPTIONAL}
                      />
                    </label>
                  </div>
                </div>

                {/* ── 제안사 (Tier 2) 연결 — 거래처 · 주소록 담당자 (v2.143.0) ── */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                  <div>
                    <ComboboxInput
                      label="제안사 업체 (거래처 목록에서 고르기)"
                      value={form.tier2CompanyName}
                      onChange={onTier2Company}
                      suggestions={companyNames}
                      placeholder="에스비유코리아 주식회사…"
                      accent="key"
                    />
                    <div className={`mt-1 text-xs ${form.tier2CompanyId ? 'text-emerald-700' : form.tier2CompanyName.trim() ? 'text-amber-700' : 'text-slate-400'}`}>
                      {form.tier2CompanyId
                        ? '✓ 거래처에 연결됩니다'
                        : form.tier2CompanyName.trim()
                          ? '⚠ 거래처 목록에 없는 이름 — 연결되지 않습니다. 아래 메모에 적어 두거나 경영지원에 거래처 등록을 요청하세요'
                          : '거래처 목록에 있는 회사는 여기서 고르세요 — 검색·집계·담당자 고르기가 정확해집니다'}
                    </div>
                  </div>
                  <div>
                    {/* ⚠라벨 높이를 `h-5` 로 못박는다 — 왼쪽 ComboboxInput 의 라벨은 줄높이가 20px(부모 text-sm 의 strut)라
                        그냥 두면 이 칸이 **4px 위로 뜬다**(실측 2026-09-18 · 605 vs 609). */}
                    <span className="flex items-center h-5 text-xs text-slate-500 mb-1">제안사 담당자 <span className="ml-1 text-slate-400">(주소록 · ✉ 만료 안내 메일의 받는사람)</span></span>
                    <div className="flex gap-1">
                      <select
                        value={form.tier2ContactId ?? ''}
                        onChange={(e) => onTier2Contact(e.target.value ? Number(e.target.value) : null)}
                        className="ui-input flex-1 min-w-0 border-amber-300 bg-amber-50/70"
                      >
                        <option value="">(없음)</option>
                        {contactOptions.map((c) => (
                          <option key={c.id} value={c.id}>
                            {c.label || c.email}{c.email ? ` · ${c.email}` : ''}{!form.tier2CompanyId ? ` — ${c.companyName}` : ''}
                          </option>
                        ))}
                      </select>
                      <button
                        type="button"
                        onClick={openNewContact}
                        title="주소록에 새 담당자를 넣고 바로 고른다"
                        className="btn btn-outline btn-sm"
                      >
                        ＋ 새 담당자
                      </button>
                    </div>
                  </div>
                </div>
                {newContact ? (
                  <div className="rounded border border-blue-200 bg-blue-50/50 p-2">
                    <div className="text-xs text-slate-600 mb-1">
                      새 담당자 — 주소록(거래처 › 거래처 담당자)에 추가되고 이 딜에 연결됩니다.
                      {newContact.companyName.trim() ? <> 회사: <b>{newContact.companyName}</b></> : null}
                    </div>
                    <div className="grid grid-cols-2 md:grid-cols-5 gap-2">
                      <input value={newContact.name} maxLength={100} onChange={(e) => setNewContact({ ...newContact, name: e.target.value })} placeholder="이름 *" className="ui-input ui-input-sm" />
                      <input value={newContact.title} maxLength={50} onChange={(e) => setNewContact({ ...newContact, title: e.target.value })} placeholder="직급" className="ui-input ui-input-sm" />
                      <input value={newContact.department} maxLength={100} onChange={(e) => setNewContact({ ...newContact, department: e.target.value })} placeholder="부서" className="ui-input ui-input-sm" />
                      <input value={newContact.email} maxLength={200} onChange={(e) => setNewContact({ ...newContact, email: e.target.value })} placeholder="이메일" className="ui-input ui-input-sm" />
                      <input value={newContact.mobile} maxLength={50} onChange={(e) => setNewContact({ ...newContact, mobile: e.target.value })} placeholder="휴대전화" className="ui-input ui-input-sm tabular-nums" />
                    </div>
                    <div className="mt-1.5 flex flex-wrap items-center gap-2">
                      {!form.tier2CompanyId ? (
                        <input value={newContact.companyName} maxLength={200} onChange={(e) => setNewContact({ ...newContact, companyName: e.target.value })} placeholder="회사 이름 *" className="ui-input ui-input-sm border-amber-300 w-56" />
                      ) : null}
                      {newContactError ? <span className="text-xs text-rose-600">{newContactError}</span> : null}
                      <div className="ml-auto flex gap-1">
                        <button type="button" onClick={() => { setNewContact(null); setNewContactError(''); }} className="btn btn-secondary btn-sm">취소</button>
                        <button type="button" onClick={saveNewContact} disabled={addContact.isPending} className="btn btn-primary btn-sm">
                          {addContact.isPending ? '넣는 중…' : '주소록에 넣고 고르기'}
                        </button>
                      </div>
                    </div>
                  </div>
                ) : null}

                {/* ⭐프로젝트명(Topic) — v2.189.0. 종전에는 「프로젝트 정보」 안에 섞여 있어서
                    인포트렌드 메일 표의 Topic 칸을 만들 수가 없었다. 영문은 사람이 적는다.
                    ⭐⭐v2.193.1 — **두 칸의 줄을 맞춘다**(사용자 지적 「설명 부분 때문에 줄이 안 맞아」).
                       창이 max-w-3xl 이라 한 칸이 353px 뿐인데 라벨에 설명까지 붙어 **오른쪽 라벨만 두 줄**이 되고
                       입력 칸이 **16px 내려앉아** 있었다(실측 2026-09-18). → 설명은 **두 칸 아래 한 줄로** 내리고
                       라벨은 짧게 + 높이를 `h-5` 로 못박는다. `items-end` 는 그래도 어긋날 때의 안전망. */}
                <div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-2 items-end">
                    <label className="block">
                      <span className="flex items-center h-5 text-xs text-slate-600 mb-1">프로젝트명</span>
                      <input
                        value={form.topic}
                        maxLength={1000}
                        onChange={(e) => setForm({ ...form, topic: e.target.value })}
                        placeholder="NDR솔루션 구축 건"
                        className={KEY_INPUT}
                      />
                    </label>
                    <label className="block">
                      <span className="flex items-center gap-2 h-5 text-xs text-slate-600 mb-1">
                        <span>프로젝트명 (영문)</span>
                        <button
                          type="button"
                          onClick={() => void fillEnglish(form)}
                          disabled={transBusy}
                          title={'우리가 과거 딜에 적어 둔 영문만 찾아 채웁니다 — 번역하지 않습니다.\n'
                            + '모르는 문장은 비워 두고 알려 드립니다. 저장은 [고치기] 를 누르셔야 됩니다.'}
                          /* ⚠`whitespace-nowrap shrink-0` 이 없으면 단추 글자가 **두 줄로 접힌다**
                             (1536 에서 높이 34px 로 실측 · 2026-09-18). */
                          className="btn btn-outline btn-sm ml-auto shrink-0"
                        >
                          {transBusy ? '찾는 중…' : '🔎 아는 영문 찾기'}
                        </button>
                      </span>
                      <input
                        value={form.topicEn}
                        maxLength={1000}
                        onChange={(e) => setForm({ ...form, topicEn: e.target.value })}
                        placeholder="Establishment of NDR Solution"
                        className={KEY_INPUT_OPTIONAL}
                      />
                    </label>
                  </div>
                  <div className="mt-1 text-xs text-slate-500">
                    인포트렌드 안내 메일 표의 <b>Topic</b> 칸 — 한글과 영문이 나란히 들어갑니다.
                  </div>
                </div>

                {/* ── 제안 품목 (P/N) — v2.193.0 에 주요 항목으로 올렸다 ── */}
                <div>
                  <span className="flex items-center gap-2 text-xs text-slate-600 mb-1">
                    제안 품목 (P/N)
                    <button
                      type="button"
                      onClick={() => { setPnPickOpen((v) => !v); setPnErr(''); }}
                      title="인포트렌드 가격표에서 모델·P/N 을 찾아 이 칸에 붙입니다 (직접 적어도 됩니다)"
                      className="btn btn-secondary btn-sm ml-auto"
                    >
                      {pnPickOpen ? '🔍 찾기 닫기' : '🔍 가격표에서 찾기'}
                    </button>
                  </span>
                  {/* ⭐품목 칸 · 수량 칸 (v2.178.0 · 사용자 요청 「칸을 품목 칸, 수량 칸 나눠줘」).
                      종전에는 여러 줄 글자 한 칸이었다. 이제 한 줄에 품목 하나 + 수량 + 비고.
                      ⚠비고는 가격($5,819)·메모(우선 등록)처럼 옛 자료에 딸려 온 곁글 자리다. */}
                  <div className="border border-amber-300 rounded divide-y divide-amber-200 bg-amber-50/70">
                    <div className="flex gap-1 px-1.5 py-1 bg-amber-100/70 text-xs text-amber-900">
                      <span className="flex-1">품목 (P/N + 이름)</span>
                      <span className="w-14 text-center">수량</span>
                      <span className="w-28">비고</span>
                      <span className="w-5" />
                    </div>
                    {form.items.map((it, i) => (
                      <div key={i} className="flex gap-1 px-1.5 py-1 items-center">
                        <input
                          value={it.item}
                          maxLength={400}
                          placeholder={it.qty === 0 ? '(메모만 있는 줄)' : ''}
                          onChange={(e) => setItem(i, { item: e.target.value })}
                          className="ui-input ui-input-sm flex-1 min-w-0 border-amber-300"
                        />
                        <input
                          type="number"
                          min={0}
                          max={100000}
                          value={it.qty}
                          onChange={(e) => setItem(i, { qty: Number(e.target.value) })}
                          className="ui-input ui-input-sm w-14 border-amber-300 text-right"
                        />
                        <input
                          value={it.note}
                          maxLength={400}
                          onChange={(e) => setItem(i, { note: e.target.value })}
                          className="ui-input ui-input-sm w-28 border-amber-300"
                        />
                        <button
                          type="button"
                          title="이 줄 빼기"
                          onClick={() => setForm({ ...form, items: form.items.filter((_, j) => j !== i) })}
                          className="w-5 text-slate-400 hover:text-rose-600"
                        >
                          ×
                        </button>
                      </div>
                    ))}
                    <div className="px-1.5 py-1">
                      <button
                        type="button"
                        onClick={() => setForm({ ...form, items: [...form.items, { item: '', qty: 1, note: '' }] })}
                        className="text-xs text-sky-700 hover:underline"
                      >
                        ＋ 줄 추가
                      </button>
                      {form.items.length === 0 && (
                        <span className="ml-2 text-xs text-slate-500">
                          [🔍 가격표에서 찾기] 로 고르거나 [＋ 줄 추가] 로 직접 적으세요
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* ── 🔗 영업진행 건 — v2.193.0 에 주요 항목 상자 **밖으로** 내렸다
                     (사용자 요청 「영업진행건은 아래로 내리고」). 연결이 없어도 딜은 성립한다. ── */}
              <div>
                <span className="block text-xs text-slate-500 mb-1">
                  영업진행 건 <span className="text-slate-400">(이 딜로 진행하는 영업건 — 영업진행 상세에도 「딜등록」 으로 보입니다)</span>
                </span>
                <div className="flex items-center gap-2">
                  <div
                    className={`flex-1 min-w-0 truncate border rounded px-2 py-1.5 text-sm bg-white ${form.salesId ? 'border-slate-300 text-slate-800 tabular-nums' : 'border-dashed border-slate-300 text-slate-400'}`}
                    title={form.salesLabel}
                  >
                    {form.salesId ? (form.salesLabel || form.salesId) : '연결 없음'}
                  </div>
                  <button type="button" onClick={() => setPickerOpen(true)} className="btn btn-secondary btn-sm">🔍 영업건 찾기</button>
                  {form.salesId ? (
                    <button type="button" onClick={() => setForm({ ...form, salesId: '', salesLabel: '' })} className="btn btn-danger btn-sm">지우기</button>
                  ) : null}
                </div>
              </div>

              <label className="block">
                <span className="block text-xs text-slate-500 mb-1">제안사 메모 — 회사 · 담당자 · 연락처 원문 <span className="text-slate-400">(위에서 고르지 못한 것을 글자로 · 주소록 담당자가 없으면 여기 적힌 메일 주소가 ✉ 받는사람)</span></span>
                <textarea
                  value={form.tier2}
                  rows={2}
                  maxLength={2000}
                  onChange={(e) => setForm({ ...form, tier2: e.target.value })}
                  placeholder={'에스비유코리아 / SBU Korea\n이종승 대표 jslee@… 010-…'}
                  className="ui-input ui-textarea w-full"
                />
              </label>

              {/* ── 프로젝트 정보 + 📝 새 업데이트 (v2.194.0) ──
                     사용자 요청: 「프로젝트 정보는 업데이트 될 경우 **별도의 칸에 새로 적을수 있게** 칸을
                     분리시켜 줘. 나중에 **누적해서 볼수는 있어야** 되고」
                     → 적는 곳을 나눴다. 위 칸 = 처음 정보(옛 경과 줄도 여기 그대로) · 아래 칸 = **새 업데이트 한 줄**.
                     ⛔[＋ 오늘 경과 줄] 단추는 뺐다 — 적는 곳이 둘이면 어디에 적어야 할지 갈린다.
                     ⚠새 업데이트는 **저장해야** 쌓인다(이력은 상세 창에서 본다). */}
              <div>
                <span className="block text-xs text-slate-500 mb-1">
                  프로젝트 정보 <span className="text-slate-400">— 제안 모델 · 처음 적은 내용 (지난 경과 줄도 여기 그대로 있습니다)</span>
                </span>
                <textarea
                  value={form.projectInfo}
                  rows={7}
                  maxLength={20000}
                  onChange={(e) => setForm({ ...form, projectInfo: e.target.value })}
                  placeholder={'Spec in Model : GS3060R x 1\n2. Project Information : …\n260908 : …'}
                  className="ui-input ui-textarea w-full"
                />
              </div>

              <div className="rounded border border-sky-200 bg-sky-50/50 p-2">
                <span className="block text-xs text-sky-900 mb-1 font-semibold">
                  📝 새 업데이트 <span className="font-normal text-sky-800/80">
                    — 진행된 내용을 여기 적으면 <b>오늘 날짜로 이력에 쌓입니다</b> (위 칸은 그대로 둡니다)
                  </span>
                </span>
                <textarea
                  value={form.newUpdate}
                  rows={2}
                  maxLength={20000}
                  onChange={(e) => setForm({ ...form, newUpdate: e.target.value })}
                  placeholder={'예) 제안서 제출 완료, 10월 중 BMT 예정'}
                  className="ui-input ui-textarea w-full border-sky-300"
                />
                {/* 💬 문구 고르기 (v2.216.0) — 쓸 말이 생각나지 않을 때 대분류 → 문구. 고르면 위 칸에 글자로 들어간다. */}
                <div className="mt-1">
                  <DealUpdatePhrasePicker value={form.newUpdate} onChange={(v) => setForm({ ...form, newUpdate: v })} />
                </div>
                <div className="mt-1 text-xs text-slate-500">
                  쌓인 이력은 <b>상세 창</b>에서 볼 수 있고, 인포트렌드 안내 메일에도 <b>지금처럼</b> 함께 나갑니다.
                  {detail && detail.id === form.id && detail.updates.length > 0
                    ? <> 지금까지 <b>{detail.updates.length}건</b> 쌓였습니다.</>
                    : null}
                </div>
              </div>

              <div>
                <span className="block text-xs text-slate-500 mb-1">
                  프로젝트 정보 (영문)
                  <span className="text-slate-400"> (인포트렌드 안내 메일에만 쓰입니다 · 비우면 한글만 나갑니다)</span>
                </span>
                <textarea
                  value={form.projectInfoEn}
                  rows={3}
                  maxLength={20000}
                  onChange={(e) => setForm({ ...form, projectInfoEn: e.target.value })}
                  placeholder={'Proposal planned after deal registration with a goal to proceed between late 2026 and early 2027'}
                  className="ui-input ui-textarea w-full"
                />
              </div>

              <label className="block">
                <span className="block text-xs text-slate-500 mb-1">Remark</span>
                <textarea
                  value={form.remark}
                  rows={2}
                  maxLength={4000}
                  onChange={(e) => setForm({ ...form, remark: e.target.value })}
                  className="ui-input ui-textarea w-full"
                />
              </label>

              {/* 🔍 가격표에서 제안 품목 찾기 (v2.151.0) — [넣기]를 누르면 위 P/N 칸 맨 아래에 한 줄로 붙는다 */}
              {pnPickOpen && (
                <div className="border border-blue-200 bg-blue-50/50 rounded p-2 space-y-2">
                  {/* 단계 고르기 — ① 본체(필수) → ② 호스트보드 → ③ 하드디스크 → ④ 기타 (v2.152.0) */}
                  <div className="flex flex-wrap items-center gap-1">
                    {pnGroups.map((g) => (
                      <button
                        key={g.key}
                        type="button"
                        onClick={() => { setPnGroup(g.key); setPnCat(''); setPnQuery(''); }}
                        title={g.hint}
                        className={`btn btn-sm ${pnGroup === g.key ? 'btn-primary' : 'btn-secondary'}`}
                      >
                        {g.label}{g.required ? ' (필수)' : ''} <span className="opacity-70">{g.count}</span>
                      </button>
                    ))}
                    <button
                      type="button"
                      onClick={() => setPnPickOpen(false)}
                      className="btn btn-secondary btn-sm ml-auto"
                    >
                      닫기
                    </button>
                  </div>

                  <div className="flex flex-wrap items-center gap-2">
                    <label className="ui-label flex items-center gap-1">
                      제품군
                      <select
                        value={pnCat}
                        onChange={(e) => setPnCat(e.target.value)}
                        className="ui-input ui-input-sm max-w-[190px]"
                      >
                        <option value="">전체 ({pnGroupNow?.count ?? 0})</option>
                        {(pnGroupNow?.cats ?? []).map((c) => (
                          <option key={c.cat} value={c.cat}>{c.label} ({c.count})</option>
                        ))}
                      </select>
                    </label>
                    <input
                      autoFocus
                      value={pnQuery}
                      onChange={(e) => setPnQuery(e.target.value)}
                      placeholder="이 묶음 안에서 찾기 (안 적으면 목록 전체) — 예: 3060 · 12Gb"
                      className="ui-input ui-input-sm flex-1 min-w-[200px]"
                    />
                    <label className="ui-label flex items-center gap-1">
                      넣을 내용
                      <select
                        value={pnInsert}
                        onChange={(e) => setPnInsert(e.target.value as 'pnName' | 'model' | 'pn' | 'modelDesc')}
                        className="ui-input ui-input-sm"
                      >
                        <option value="pnName">P/N + 이름 (기본)</option>
                        <option value="model">모델명</option>
                        <option value="pn">P/N</option>
                        <option value="modelDesc">모델명 + 설명</option>
                      </select>
                    </label>
                  </div>

                  {pnGroupNow && (
                    <p className="text-xs text-slate-500">{pnGroupNow.hint}</p>
                  )}
                  {pnGroup !== 'main' && !form.pn.trim() && (
                    <p className="text-xs text-amber-700">
                      ① <b>본체를 먼저</b> 고르시는 것이 좋습니다 — 본체 외에는 안 넣어도 됩니다.
                    </p>
                  )}
                  {pnErr && <p className="text-xs text-rose-700">⚠ {pnErr}</p>}
                  {pnBusy && <p className="text-xs text-slate-500">찾는 중…</p>}
                  {!pnBusy && !pnErr && pnRows.length === 0 && (
                    <p className="text-xs text-slate-600">
                      해당하는 품목이 없습니다 — 위 칸에 직접 적으셔도 됩니다.
                    </p>
                  )}
                  {pnOldQuarter && pnRows.length > 0 && (
                    <p className="text-xs text-amber-700">현재 분기 가격표에 없어 <b>지난 분기</b>까지 찾았습니다.</p>
                  )}
                  {pnRows.length > 0 && (
                    <div className="max-h-64 overflow-y-auto border border-slate-200 rounded bg-white">
                      <table className="w-full text-xs table-fixed">
                        <thead className="bg-slate-50 text-slate-600 sticky top-0">
                          <tr>
                            <th className="text-left px-2 py-1 font-medium w-[130px]">모델</th>
                            <th className="text-left px-2 py-1 font-medium w-[150px]">P/N</th>
                            <th className="text-left px-2 py-1 font-medium">설명</th>
                            <th className="text-left px-2 py-1 font-medium w-[120px]">구성</th>
                            <th className="px-2 py-1 w-[62px]" />
                          </tr>
                        </thead>
                        <tbody>
                          {pnRows.map((r) => (
                            <tr key={r.id} className="border-t border-slate-100 hover:bg-slate-50 align-top">
                              <td className="px-2 py-1 font-medium text-slate-800 truncate" title={r.model ?? ''}>
                                {r.model || '-'}
                              </td>
                              <td className="px-2 py-1 text-slate-600 truncate" title={String(r.pn ?? '')}>
                                {String(r.pn ?? '').split(/[\r\n]+/)[0] || '-'}
                              </td>
                              <td className="px-2 py-1 text-slate-500 truncate" title={r.description ?? ''}>
                                {(r.description ?? '').replace(/\s+/g, ' ').trim() || '-'}
                                {!r.is_current && <span className="ml-1 text-amber-700">({r.quarter_label})</span>}
                              </td>
                              <td className="px-2 py-1 text-slate-500 truncate">
                                {[r.form, r.drive, r.dram].filter(Boolean).join(' · ') || '-'}
                              </td>
                              <td className="px-2 py-1 text-right">
                                <button
                                  type="button"
                                  onClick={() => addPart(r)}
                                  className="btn btn-outline btn-sm"
                                >
                                  넣기
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              )}

              <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                <div>
                  <span className="block text-xs text-slate-500 mb-1">애플리케이션 <span className="text-slate-400">(인포트렌드 목록에서 고르기)</span></span>
                  <select
                    value={appOther ? OTHER_APP : form.application}
                    onChange={(e) => {
                      if (e.target.value === OTHER_APP) { setAppOther(true); return; }
                      setAppOther(false);
                      setForm({ ...form, application: e.target.value });
                    }}
                    className="ui-input w-full"
                  >
                    <option value="">(없음)</option>
                    {(meta.data?.applications ?? []).map((g) => (
                      <optgroup key={g.group} label={g.group}>
                        {g.items.map((it) => <option key={it} value={it}>{it}</option>)}
                      </optgroup>
                    ))}
                    <option value={OTHER_APP}>직접 입력…</option>
                  </select>
                  {appOther ? (
                    <input
                      value={form.application}
                      maxLength={200}
                      onChange={(e) => setForm({ ...form, application: e.target.value })}
                      placeholder="목록에 없는 값 (엑셀 시절 값 등)"
                      className="ui-input mt-1 w-full border-amber-300"
                    />
                  ) : null}
                </div>
                <label className="block">
                  <span className="block text-xs text-slate-500 mb-1">
                    금액(USD) <span className="text-slate-400">(딜 금액 · 숫자만)</span>
                  </span>
                  <input
                    value={form.amountUsd}
                    inputMode="decimal"
                    maxLength={20}
                    onChange={(e) => setForm({ ...form, amountUsd: e.target.value })}
                    placeholder="예: 418448"
                    className="ui-input w-full text-right tabular-nums"
                  />
                </label>
                <label className="block md:col-span-2">
                  <span className="block text-xs text-slate-500 mb-1">비고</span>
                  <input
                    value={form.note}
                    maxLength={4000}
                    onChange={(e) => setForm({ ...form, note: e.target.value })}
                    className="ui-input w-full"
                  />
                </label>
              </div>

              {formError ? (
                <div className="text-xs text-rose-600 bg-rose-50 border border-rose-200 rounded px-2 py-1.5">{formError}</div>
              ) : null}
            </div>
            <div className="px-4 py-3 border-t border-slate-200 flex justify-end gap-2">
              <button
                type="button"
                onClick={() => setForm(null)}
                disabled={saving}
                className="btn btn-secondary"
              >
                취소
              </button>
              <button
                type="button"
                onClick={submit}
                disabled={saving}
                className="btn btn-primary"
              >
                {saving ? '저장 중…' : form.id ? '고치기' : '넣기'}
              </button>
            </div>
          </div>
          {/* 영업건 찾기 — 폼 창 안에 두어 폼(z-80) 위에 뜬다 (자기 z-70 은 이 안에서만 셈) */}
          <SalesPickerModal
            open={pickerOpen}
            onClose={() => setPickerOpen(false)}
            onPick={(row) => {
              setForm((f) => (f ? { ...f, salesId: row.salesId, salesLabel: `${row.salesId}${row.projectName ? ' · ' + row.projectName : ''}` } : f));
              setPickerOpen(false);
            }}
            title="딜등록에 연결할 영업건 찾기"
            initialQuery={form.tier2CompanyName || undefined}
          />
        </div>
      ) : null}

      {/* ✏ 만료 안내 문구 (v2.147.0) — 보기는 영업 이상, 고치기는 경영지원·관리자(서버가 막는다) */}
      {templateOpen ? <ExpiryMailTemplateModal onClose={() => setTemplateOpen(false)} /> : null}
      {archiveOpen ? (
        <DealArchiveModal
          vendor={vendor}
          onClose={() => setArchiveOpen(false)}
          onDone={(moved, skipped) => {
            setArchiveOpen(false);
            setNotice(`📦 ${moved}건을 종료 탭으로 넘겼습니다${skipped ? ` (그 사이 진행으로 바뀐 ${skipped}건은 건너뛰었습니다)` : ''}.`);
          }}
        />
      ) : null}

      {reqDialog ? (
        <DealRequestDialog
          contacts={contactRows}
          initial={reqDialog.initial}
          dealId={reqDialog.dealId}
          onClose={() => setReqDialog(null)}
          onSent={(row) => {
            setNotice(`✉ ${row.company || row.toEmails.join(', ')} 에 딜등록 정보 요청을 보냈습니다 — [✉ 정보 요청] 탭에 기록했습니다.`);
            refresh();
          }}
        />
      ) : null}
    </div>
  );
}

/** 「최근 변경」 칸의 값(정렬·🔍) — 시각이 앞이라 글자순 정렬 = 시간순 */
function lastChangeText(c: DealLastChange | null | undefined): string {
  return c ? `${c.at} ${c.byName} ${c.labels.join(' · ')}` : '';
}

/** 7일 안에 바뀌었나 — 목록에 ● 를 붙인다 */
function changedWithinDays(at: string, days: number): boolean {
  const t = Date.parse(at.replace(' ', 'T') + ':00+09:00');
  return Number.isFinite(t) && Date.now() - t < days * 86_400_000;
}

/** 목록 「최근 변경」 칸 — 첫 줄 날짜·이름, 둘째 줄 바뀐 칸 */
function LastChangeCell({ c }: { c: DealLastChange | null | undefined }): React.JSX.Element {
  if (!c) return <span className="text-slate-400">-</span>;
  const what = c.labels.join(' · ');
  const tip = `${c.at} · ${c.byName}\n바뀐 칸: ${what || '-'}${c.statusChanged ? '' : '\n(상태는 그대로 두고 내용만 고쳤습니다)'}`;
  return (
    <div title={tip}>
      <div className="truncate tabular-nums">
        {changedWithinDays(c.at, 7) ? <span className="text-amber-500" aria-label="7일 안에 바뀜">● </span> : null}
        {c.at.slice(5, 10)} {c.byName}
      </div>
      <div className="truncate text-slate-500">{what || '-'}</div>
    </div>
  );
}

/**
 * 상세 창 「🕘 최근 변경 · 변경 이력」 (v2.306.0) — 누가·언제·어느 칸을·무엇에서 무엇으로.
 *   이력은 펼칠 때만 받는다(서버 audit_log · GET /deal-registrations/:id/audit).
 *   업데이트 글은 위 「📝 업데이트 이력」에 있어 여기엔 안 싣는다.
 */
function DealChangeBox({ dealId, lastChange }: { dealId: number; lastChange: DealLastChange | null }): React.JSX.Element {
  const [open, setOpen] = useState(false);
  const q = useQuery({ queryKey: ['deal-audit', dealId], queryFn: () => getDealAudit(dealId), enabled: open, staleTime: 0 });
  // 같은 저장(같은 초·같은 사람)을 한 묶음으로
  const groups = useMemo(() => {
    const out: { key: string; at: string; who: string; auto: boolean; rows: NonNullable<typeof q.data> }[] = [];
    for (const r of q.data ?? []) {
      const key = `${r.changedAt}|${r.userId}`;
      const last = out[out.length - 1];
      if (last && last.key === key) last.rows.push(r);
      else out.push({ key, at: r.changedAt, who: r.auto ? '자동' : (r.userName || r.userId), auto: r.auto, rows: [r] });
    }
    return out;
  }, [q.data]);
  return (
    <div className="rounded border border-slate-200" data-deal-change>
      <div className="flex items-center gap-2 px-2 py-1.5 bg-slate-50 text-xs">
        <span className="font-semibold text-slate-700">🕘 최근 변경</span>
        {lastChange ? (
          <span className="text-slate-700 tabular-nums">
            {lastChange.at} · {lastChange.byName} · {lastChange.labels.join(' · ') || '-'}
            {!lastChange.statusChanged ? <span className="ml-1 text-amber-700">(상태는 그대로 · 내용만 고침)</span> : null}
          </span>
        ) : (
          <span className="text-slate-400">사람이 바꾼 기록이 없습니다</span>
        )}
        <button type="button" onClick={() => setOpen((v) => !v)} className="btn btn-sm btn-secondary ml-auto" aria-expanded={open}>
          {open ? '변경 이력 접기' : '변경 이력 보기'}
        </button>
      </div>
      {open ? (
        <div className="max-h-72 overflow-y-auto text-xs">
          {q.isPending ? <div className="px-2 py-2 text-slate-400"><LoadingLines /></div> : null}
          {q.isError ? <div className="px-2 py-2 text-red-600">이력을 못 불러왔습니다 — {(q.error as Error).message}</div> : null}
          {q.data && groups.length === 0 ? <div className="px-2 py-2 text-slate-400">기록이 없습니다</div> : null}
          {groups.map((g) => (
            <div key={g.key} className="border-t border-slate-100 px-2 py-1.5">
              <div className="text-slate-500 tabular-nums">
                {g.at.slice(0, 16)} · <span className={g.auto ? 'text-slate-400' : 'text-slate-700 font-medium'}>{g.who}</span>
              </div>
              {g.rows.map((r) => (
                <div key={r.logId} className="pl-3 break-words">
                  {r.action === 'INSERT' ? (
                    <span className="text-emerald-700">새로 등록</span>
                  ) : (
                    <>
                      <span className="text-slate-600">{r.label}</span>{' '}
                      <span className="text-slate-400 line-through">{r.oldValue || '(빈 칸)'}</span>
                      <span className="text-slate-400"> → </span>
                      <span className="text-slate-800">{r.newValue || '(빈 칸)'}</span>
                    </>
                  )}
                </div>
              ))}
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
}

function Field({ label, children }: { label: string; children: React.ReactNode }): React.JSX.Element {
  return (
    <div className="rounded bg-slate-50 px-2 py-1.5">
      <div className="text-xs text-slate-500">{label}</div>
      <div className="text-slate-800 tabular-nums">{children}</div>
    </div>
  );
}

/**
 * 상세 창의 **제안 품목** — 품목 칸 · 수량 칸 · 비고 칸으로 나눠서 보여 준다 (v2.178.1).
 * ⚠품목 줄이 아직 없는 딜은 `fallbackText`(pn 글자)를 종전 모양 그대로 보여 준다 — 빈 칸으로 두지 않는다.
 */
function ItemsBlock({ items, fallbackText }: { items: DealItem[]; fallbackText: string }): React.JSX.Element {
  if (!items || items.length === 0) return <Block label="제안 품목 (P/N)" text={fallbackText} />;
  return (
    <div>
      <div className="text-xs text-slate-500 mb-0.5">제안 품목 (P/N) — {items.filter((i) => i.item).length}줄</div>
      <div className="rounded border border-slate-200 overflow-hidden">
        <div className="flex gap-1 px-2 py-1 bg-slate-50 text-xs text-slate-500">
          <span className="flex-1">품목</span>
          <span className="w-10 text-right">수량</span>
          <span className="w-24">비고</span>
        </div>
        {items.map((it, i) => (
          <div key={i} className="flex gap-1 px-2 py-1 text-[13px] border-t border-slate-100">
            {it.item ? (
              <>
                <span className="flex-1 break-words">{it.item}</span>
                <span className="w-10 text-right tabular-nums">{it.qty}</span>
                <span className="w-24 break-words text-xs text-slate-500">{it.note || ''}</span>
              </>
            ) : (
              // 품목 없이 비고만 있는 메모 줄
              <span className="flex-1 text-[12px] text-slate-500">({it.note})</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

/**
 * 📝 프로젝트 정보 업데이트 이력 (v2.194.0)
 *
 * 사용자 요청: 「업데이트 될 경우 별도의 칸에 새로 적을수 있게 … 나중에 누적해서 볼수는 있어야 되고」
 * ⭐**오래된 것이 위** — 엑셀 시절 경과 줄과 같은 방향이고, 위 「프로젝트 정보」 칸의 옛 줄에서 그대로 이어진다.
 * ⚠적은 사람 이름은 **여기에만** 보인다 — 안내 메일에는 날짜와 내용만 나간다.
 */
function UpdateLog({ deal, busy, onAdd, onEdit, onRemove }: {
  deal: DealRow;
  busy: boolean;
  onAdd: (body: string) => void;
  onEdit: (updateId: number, body: string, date?: string) => void;
  onRemove: (updateId: number) => void;
}): React.JSX.Element {
  const [draft, setDraft] = useState('');
  const [editId, setEditId] = useState<number | null>(null);
  const [editBody, setEditBody] = useState('');
  const add = (): void => {
    const body = draft.trim();
    if (!body) return;
    onAdd(body);
    setDraft('');
  };
  return (
    <div>
      <div className="text-xs text-slate-500 mb-0.5">
        📝 업데이트 이력 <span className="text-slate-400">— 새로 적은 진행 경과 (안내 메일에도 함께 나갑니다)</span>
      </div>
      <div className="rounded border border-slate-200 divide-y divide-slate-100">
        {deal.updates.length === 0 ? (
          <div className="px-2 py-1.5 text-[13px] text-slate-400">
            아직 없습니다 — 아래에 적거나 [수정] 창의 「📝 새 업데이트」 칸에 적으면 쌓입니다.
          </div>
        ) : deal.updates.map((u) => (
          <div key={u.id} className="px-2 py-1.5 text-[13px] flex gap-2 items-start">
            <span className="tabular-nums whitespace-nowrap text-slate-500 shrink-0">{u.date.slice(2).replace(/-/g, '')}</span>
            {editId === u.id ? (
              <>
                <textarea
                  value={editBody}
                  rows={2}
                  maxLength={20000}
                  onChange={(e) => setEditBody(e.target.value)}
                  className="ui-input ui-textarea flex-1 min-w-0"
                />
                <button
                  type="button"
                  disabled={busy || editBody.trim() === ''}
                  onClick={() => { onEdit(u.id, editBody.trim()); setEditId(null); }}
                  className="btn btn-primary btn-sm shrink-0"
                >
                  고치기
                </button>
                <button
                  type="button"
                  onClick={() => setEditId(null)}
                  className="btn btn-secondary btn-sm shrink-0"
                >
                  취소
                </button>
              </>
            ) : (
              <>
                <span className="flex-1 min-w-0 whitespace-pre-wrap break-words">{u.body}</span>
                {u.byName || u.by ? (
                  <span className="shrink-0 text-xs text-slate-500 whitespace-nowrap">{u.byName || u.by}</span>
                ) : null}
                <button
                  type="button"
                  title="이 업데이트 고치기"
                  onClick={() => { setEditId(u.id); setEditBody(u.body); }}
                  className="shrink-0 text-slate-500 hover:text-blue-600 text-xs"
                >
                  ✏
                </button>
                <button
                  type="button"
                  title="이 업데이트 지우기"
                  disabled={busy}
                  onClick={() => onRemove(u.id)}
                  className="shrink-0 text-slate-500 hover:text-rose-600 text-xs disabled:opacity-40"
                >
                  ×
                </button>
              </>
            )}
          </div>
        ))}
        <div className="px-2 py-1.5 bg-slate-50/60 space-y-1">
          {/* 💬 문구 고르기 (v2.216.0) — 고르면 아래 칸에 글자로 들어간다 · 저장은 [넣기] */}
          <DealUpdatePhrasePicker value={draft} onChange={setDraft} />
          <div className="flex gap-2 items-start">
            <textarea
              value={draft}
              rows={Math.min(4, Math.max(1, draft.split('\n').length))}
              maxLength={20000}
              placeholder="진행된 내용을 적고 [넣기] — 오늘 날짜로 쌓입니다"
              onChange={(e) => setDraft(e.target.value)}
              className="ui-input ui-textarea flex-1 min-w-0"
            />
            <button
              type="button"
              disabled={busy || draft.trim() === ''}
              onClick={add}
              className="btn btn-primary btn-sm shrink-0"
            >
              넣기
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

function Block({ label, text, tall }: { label: string; text: string; tall?: boolean }): React.JSX.Element {
  return (
    <div>
      <div className="text-xs text-slate-500 mb-0.5">{label}</div>
      <div className={`whitespace-pre-wrap break-words rounded border border-slate-200 px-2 py-1.5 text-[13px] leading-relaxed ${tall ? 'max-h-72 overflow-y-auto' : ''}`}>
        {text || <span className="text-slate-400">-</span>}
      </div>
    </div>
  );
}
